// THIS FILE IS GENERATED, DO NOT EDIT!
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  Json: any;
};

export enum Actor {
  Admin = 'ADMIN',
  Buyer = 'BUYER',
  Seller = 'SELLER',
}

export type AddShipFromAddressInput = {
  address: CreateAddressInput;
  bundleId: Scalars['ID'];
};

export type Address = {
  addressLine1: Scalars['String'];
  addressLine2?: Maybe<Scalars['String']>;
  billingOrder?: Maybe<Order>;
  city: Scalars['String'];
  country: Scalars['String'];
  createdAt: Scalars['DateTime'];
  fullName: Scalars['String'];
  id: Scalars['ID'];
  phone?: Maybe<Scalars['String']>;
  shippingOrder?: Maybe<Order>;
  state: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  zip: Scalars['String'];
};

export type AddressPayload = {
  address: Address;
};

export type AdminUpdateBundleInput = {
  id: Scalars['ID'];
  verifyAt?: InputMaybe<Scalars['DateTime']>;
};

export type AlloyIntegration = {
  installed: Scalars['Boolean'];
  integrationId: Scalars['ID'];
};

export type BrandHealthAction = {
  actionButtonLink?: Maybe<Scalars['String']>;
  actionButtonText?: Maybe<Scalars['String']>;
  categories: Array<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  excludeForExperiences?: Maybe<Array<Maybe<Scalars['String']>>>;
  impact: Scalars['String'];
  implementationInstructions?: Maybe<Scalars['String']>;
  includeForExperiences: Array<Scalars['String']>;
  key: Scalars['String'];
  time: Scalars['String'];
  title: Scalars['String'];
  whyExplainer?: Maybe<Scalars['String']>;
};

export enum BrandHealthGrade {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  F = 'F',
  S = 'S',
  Unknown = 'UNKNOWN',
}

export type BrandHealthLog = {
  actionsTaken: Scalars['Json'];
  businessMetrics: Scalars['Json'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  inventoryScore: Scalars['Float'];
  inventoryScoreGrade: BrandHealthGrade;
  overallScore: Scalars['Float'];
  overallScoreGrade: BrandHealthGrade;
  promotionScore: Scalars['Float'];
  promotionScoreGrade: BrandHealthGrade;
  shopId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type Bundle = {
  bundleItems: Array<BundleItem>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  creditCode?: Maybe<CreditCode>;
  currency: Currency;
  expireAt?: Maybe<Scalars['DateTime']>;
  fulfillment?: Maybe<Fulfillment>;
  id: Scalars['ID'];
  isBrandDirect: Scalars['Boolean'];
  isMarkedFulfilled?: Maybe<Scalars['Boolean']>;
  isReturnable?: Maybe<Scalars['Boolean']>;
  lineItems: Array<LineItem>;
  nextAutoTransition?: Maybe<BundleAutomaticTransition>;
  order: Order;
  payoutOption?: Maybe<PayoutType>;
  refunds: Array<Refund>;
  returnFulfillment?: Maybe<Fulfillment>;
  sharetribeSellerId: Scalars['String'];
  sharetribeTransactionIds: Array<Scalars['String']>;
  shipFromAddress?: Maybe<Address>;
  shopifyOrderId?: Maybe<Scalars['String']>;
  status: BundleStatus;
  type?: Maybe<BundleType>;
  updatedAt: Scalars['DateTime'];
  verifyAt?: Maybe<Scalars['DateTime']>;
};

export type BundleAutomaticTransition = {
  nextStatus: BundleStatus;
  transition: BundleTransition;
  transitionAt: Scalars['DateTime'];
};

export type BundleItem = {
  bundle: Bundle;
  createdAt: Scalars['DateTime'];
  dispute?: Maybe<Dispute>;
  historicalStatuses: Array<BundleItemHistoricalStatus>;
  id: Scalars['ID'];
  listing: Listing;
  status?: Maybe<ItemStatus>;
  updatedAt: Scalars['DateTime'];
};

export enum BundleItemHistoricalStatus {
  Canceled = 'CANCELED',
  Delivered = 'DELIVERED',
  Disputed = 'DISPUTED',
  DisputeAccepted = 'DISPUTE_ACCEPTED',
  DisputeResolved = 'DISPUTE_RESOLVED',
  PaidOut = 'PAID_OUT',
  Verified = 'VERIFIED',
}

export type BundleItemPayload = {
  bundleItem: BundleItem;
};

export type BundlePayload = {
  bundle: Bundle;
};

export enum BundleStatus {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Delivered = 'DELIVERED',
  Disputed = 'DISPUTED',
  Initiated = 'INITIATED',
  Open = 'OPEN',
  Resolved = 'RESOLVED',
  Shipped = 'SHIPPED',
}

export enum BundleTransition {
  ExpireBundle = 'EXPIRE_BUNDLE',
  ExpireDispute = 'EXPIRE_DISPUTE',
  VerifyBundle = 'VERIFY_BUNDLE',
}

export enum BundleType {
  Marketplace = 'MARKETPLACE',
  TradeIn = 'TRADE_IN',
}

export enum Cadence {
  Immediately = 'IMMEDIATELY',
  Never = 'NEVER',
  Weekly = 'WEEKLY',
}

export enum CancelReason {
  CanceledFromShopify = 'CANCELED_FROM_SHOPIFY',
  KeepItem = 'KEEP_ITEM',
  Other = 'OTHER',
  ShippingExpired = 'SHIPPING_EXPIRED',
  SoldElsewhere = 'SOLD_ELSEWHERE',
}

export type Cancellation = {
  bundle: Bundle;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  initiatedBy: Actor;
  note?: Maybe<Scalars['String']>;
  reason: CancelReason;
  updatedAt: Scalars['DateTime'];
};

export type CancellationPayload = {
  cancellation: Cancellation;
};

export type CartItem = {
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  listing: Listing;
  listingId: Scalars['String'];
  quantity: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
  user: User;
  userId: Scalars['String'];
};

export type CartItemDeletePayload = {
  count: Scalars['Int'];
};

export type CartItemPayload = {
  cartItem: CartItem;
};

export enum CountryCode {
  Au = 'AU',
  Ca = 'CA',
  De = 'DE',
  Es = 'ES',
  Fr = 'FR',
  Gb = 'GB',
  It = 'IT',
  Nl = 'NL',
  Us = 'US',
}

export type Courier = {
  name: Scalars['String'];
  otherName?: Maybe<Scalars['String']>;
  serviceFromCountryRegions: Array<Maybe<Scalars['String']>>;
  slug: Scalars['String'];
  webUrl: Scalars['String'];
};

export type CreateAddressInput = {
  addressLine1: Scalars['String'];
  addressLine2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  fullName: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  state: Scalars['String'];
  zip: Scalars['String'];
};

export type CreateCancellationInput = {
  bundleId: Scalars['String'];
  bundleItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  initiatedBy: Actor;
  note?: InputMaybe<Scalars['String']>;
  reason: CancelReason;
};

export type CreateCartItemInput = {
  sharetribeListingId: Scalars['String'];
};

export type CreateFavoritedItemInput = {
  sharetribeListingId: Scalars['String'];
};

export type CreateFulfillmentFromTrackingInfoInput = {
  aftershipCourierSlug: Scalars['String'];
  bundleId: Scalars['String'];
  isReturn: Scalars['Boolean'];
  trackingNumber: Scalars['String'];
};

export type CreateFulfillmentInput = {
  bundleId: Scalars['ID'];
  isReturn?: InputMaybe<Scalars['Boolean']>;
  trackingNumber: Scalars['String'];
  trackingURL: Scalars['String'];
};

export type CreateListingFeedbackInput = {
  /** Corresponds to the feedback categories displayed in the frontend. */
  category: Scalars['String'];
  email: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  sharetribeListingId: Scalars['String'];
  sharetribeUserId?: InputMaybe<Scalars['String']>;
};

export type CreateRefundInput = {
  bundleId: Scalars['String'];
  bundleItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  currency: Currency;
  note?: InputMaybe<Scalars['String']>;
  price: Scalars['Int'];
  refundedLineItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type: RefundType;
};

export type CreateUserInput = {
  createdFromShopId: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  preferredLocale?: InputMaybe<Locale>;
  sharetribeUserId: Scalars['String'];
};

export type CreditCode = {
  amount: Scalars['Int'];
  bundle: Bundle;
  createdAt: Scalars['DateTime'];
  currency: Currency;
  expireAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  /** Codes that were combined and no longer active */
  inactiveCodes: Array<Scalars['String']>;
  maskedCode?: Maybe<Scalars['String']>;
  provider: CreditCodeProvider;
  type: CreditCodeType;
  updatedAt: Scalars['DateTime'];
};

export enum CreditCodeProvider {
  Bigcommerce = 'BIGCOMMERCE',
  Dopple = 'DOPPLE',
  Givex = 'GIVEX',
  Magento = 'MAGENTO',
  Pact = 'PACT',
  RiseAi = 'RISE_AI',
  Shopify = 'SHOPIFY',
  TeamworkCommerce = 'TEAMWORK_COMMERCE',
  Yotpo = 'YOTPO',
}

export enum CreditCodeType {
  DiscountCode = 'DISCOUNT_CODE',
  GiftCard = 'GIFT_CARD',
  LoyaltyPoints = 'LOYALTY_POINTS',
  PactCash = 'PACT_CASH',
}

export enum Currency {
  Aud = 'AUD',
  Cad = 'CAD',
  Eur = 'EUR',
  Gbp = 'GBP',
  Usd = 'USD',
}

export type CurrentUser = {
  hasSales?: Maybe<Scalars['Boolean']>;
};

export type Disbursement = {
  /** Stored in smallest unit */
  additionalCostsTotal: Scalars['Int'];
  additionalLineItems?: Maybe<Scalars['Json']>;
  /** Stored in smallest unit */
  brandCoveredDiscountsTotal?: Maybe<Scalars['Int']>;
  /** Stored in smallest unit */
  brandCoveredShippingCostTotal?: Maybe<Scalars['Int']>;
  /** Stored in smallest unit */
  brandDirectSalesGMVTotal?: Maybe<Scalars['Int']>;
  /** Stored in smallest unit */
  brandDirectSalesPayoutTotal: Scalars['Int'];
  bundles: Array<Bundle>;
  /** Stored in smallest unit */
  ccProcessingTotal: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  currency: Currency;
  /** Stored in smallest unit */
  customerPaidTotal: Scalars['Int'];
  disbursedToEmail?: Maybe<Scalars['String']>;
  /** Stored in smallest unit */
  discountsTotal?: Maybe<Scalars['Int']>;
  /** Stored in smallest unit */
  earningsTotal: Scalars['Int'];
  endDate: Scalars['DateTime'];
  /** Stored in smallest unit */
  finalDepositTotal?: Maybe<Scalars['Int']>;
  /** Stored in smallest unit */
  grossMarginTotal: Scalars['Int'];
  /** Stored in smallest unit */
  grossMerchandiseValueTotal: Scalars['Int'];
  id: Scalars['ID'];
  /** Stored in smallest unit */
  peerCashSalesGMVTotal?: Maybe<Scalars['Int']>;
  /** Stored in smallest unit */
  peerCreditSalesGMVTotal?: Maybe<Scalars['Int']>;
  /** Stored in smallest unit */
  peerSellerPayoutTotal?: Maybe<Scalars['Int']>;
  /** Stored in smallest unit */
  previouslyDepositedTotal?: Maybe<Scalars['Int']>;
  /** Stored in smallest unit */
  reimbursedShippingCostTotal?: Maybe<Scalars['Int']>;
  /** Stored in smallest unit */
  reimbursementsTotal: Scalars['Int'];
  /** Stored in smallest unit */
  relistedTradeInSalesGMVTotal?: Maybe<Scalars['Int']>;
  /** Stored in smallest unit */
  relistedTradeInSalesPayoutTotal: Scalars['Int'];
  /** Stored in smallest unit */
  returnInsuranceTotal?: Maybe<Scalars['Int']>;
  /** Stored in smallest unit */
  returnShippingCostTotal?: Maybe<Scalars['Int']>;
  /** Stored in smallest unit */
  salesCostTotal: Scalars['Int'];
  /** Stored in smallest unit */
  shippingTotal?: Maybe<Scalars['Int']>;
  shop: Shop;
  startDate: Scalars['DateTime'];
  status: DisbursementStatus;
  /** Stored in smallest unit */
  taxTotal?: Maybe<Scalars['Int']>;
  /** Stored in smallest unit */
  treetTakeTotal: Scalars['Int'];
  type: DisbursementType;
  updatedAt: Scalars['DateTime'];
};

export enum DisbursementStatus {
  AwaitingBankInfo = 'AWAITING_BANK_INFO',
  Failure = 'FAILURE',
  Initiated = 'INITIATED',
  PaidOut = 'PAID_OUT',
}

export enum DisbursementType {
  Disbursement = 'DISBURSEMENT',
  Report = 'REPORT',
}

export type DiscountLineItem = {
  createdAt: Scalars['DateTime'];
  currency: Currency;
  id: Scalars['ID'];
  lineItem: LineItem;
  metadata: Scalars['Json'];
  target: DiscountTarget;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  value: Scalars['Float'];
  valueType: DiscountValueType;
};

export enum DiscountTarget {
  All = 'ALL',
}

export enum DiscountValueType {
  FixedAmount = 'FIXED_AMOUNT',
  Percentage = 'PERCENTAGE',
}

export type Dispute = {
  bundle: Bundle;
  bundleItem: BundleItem;
  createdAt: Scalars['DateTime'];
  expireAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  reason: DisputeReason;
  status: DisputeStatus;
  updatedAt: Scalars['DateTime'];
};

export type DisputePayload = {
  dispute: Dispute;
};

export enum DisputeReason {
  ConditionAdjustment = 'CONDITION_ADJUSTMENT',
  DamagedButAcceptable = 'DAMAGED_BUT_ACCEPTABLE',
  DamagedOrLost = 'DAMAGED_OR_LOST',
  DidNotFit = 'DID_NOT_FIT',
  DidNotLike = 'DID_NOT_LIKE',
  FoundAlternative = 'FOUND_ALTERNATIVE',
  Inauthentic = 'INAUTHENTIC',
  InauthenticOrExcessiveDamage = 'INAUTHENTIC_OR_EXCESSIVE_DAMAGE',
  Missing = 'MISSING',
  None = 'NONE',
  NotAcceptable = 'NOT_ACCEPTABLE',
  NotAsDescribed = 'NOT_AS_DESCRIBED',
  Other = 'OTHER',
  WrongItem = 'WRONG_ITEM',
}

export enum DisputeStatus {
  Accepted = 'ACCEPTED',
  Expired = 'EXPIRED',
  Open = 'OPEN',
  Rejected = 'REJECTED',
}

export type DisputesPayload = {
  disputes: Array<Dispute>;
};

export type DraftListing = {
  categories: Array<Scalars['String']>;
  condition?: Maybe<ListingCondition>;
  createdAt: Scalars['DateTime'];
  currency?: Maybe<Currency>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  findItemMethod?: Maybe<FindItemMethod>;
  id: Scalars['ID'];
  itemBrand?: Maybe<Scalars['String']>;
  itemType?: Maybe<ListingItemType>;
  listingFlowMetadata?: Maybe<Scalars['Json']>;
  notes?: Maybe<Scalars['String']>;
  originalPrice?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
  priceDropConfigJson?: Maybe<Scalars['Json']>;
  privateSellerNotes?: Maybe<Scalars['String']>;
  product?: Maybe<Product>;
  productHtml?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  productVariant?: Maybe<ProductVariant>;
  productVariantId?: Maybe<Scalars['String']>;
  publishedListing?: Maybe<Listing>;
  publishedListingId?: Maybe<Scalars['String']>;
  quirks: Array<Scalars['String']>;
  selectedVariantOptions?: Maybe<Scalars['Json']>;
  seller?: Maybe<User>;
  sellerId?: Maybe<Scalars['String']>;
  sellerPhotos: Array<Scalars['Json']>;
  sharetribeListingId?: Maybe<Scalars['String']>;
  shop: Shop;
  shopId: Scalars['String'];
  sourceListing?: Maybe<Listing>;
  sourceListingId?: Maybe<Scalars['String']>;
  state: DraftListingState;
  stockPhotoUrls: Array<Scalars['String']>;
  tags: Array<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type DraftListingFilterInput = {
  shopId?: InputMaybe<Scalars['ID']>;
  sourceListingId?: InputMaybe<Scalars['ID']>;
};

export type DraftListingInput = {
  id: Scalars['ID'];
};

export enum DraftListingState {
  Deleted = 'DELETED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
}

export enum EmailSubscribeSource {
  Checkout = 'CHECKOUT',
  Footer = 'FOOTER',
  LandingPageModal = 'LANDING_PAGE_MODAL',
  ListingPageIso = 'LISTING_PAGE_ISO',
  NotificationSettings = 'NOTIFICATION_SETTINGS',
  ProfileDropdown = 'PROFILE_DROPDOWN',
  ProfileDropdownIso = 'PROFILE_DROPDOWN_ISO',
  SearchResultsBanner = 'SEARCH_RESULTS_BANNER',
  SearchResultsBannerIso = 'SEARCH_RESULTS_BANNER_ISO',
  TreetShopFooter = 'TREET_SHOP_FOOTER',
}

export type ExtendBundleShippingInput = {
  extendedShipDate: Scalars['DateTime'];
  id: Scalars['ID'];
};

export type ExtendDisputesExpirationDateInput = {
  bundleId: Scalars['String'];
  extendedExpirationDate: Scalars['DateTime'];
};

export type FavoritedItem = {
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  listing: Listing;
  listingId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  user: User;
  userId: Scalars['String'];
};

export type FavoritedItemListing = {
  id: Scalars['String'];
  sharetribeListingId: Scalars['String'];
};

export type FavoritedItemPayload = {
  favoritedItem: FavoritedItem;
};

export type FavoritedItemQueryPayload = {
  id: Scalars['String'];
  listing: FavoritedItemListing;
};

export enum FindItemMethod {
  AllProducts = 'ALL_PRODUCTS',
  ApiUpload = 'API_UPLOAD',
  CannotFind = 'CANNOT_FIND',
  EmailAccount = 'EMAIL_ACCOUNT',
  ListAnyBrand = 'LIST_ANY_BRAND',
  Manual = 'MANUAL',
  OrderNumber = 'ORDER_NUMBER',
  RelistAsDuplicate = 'RELIST_AS_DUPLICATE',
  RelistFromTreet = 'RELIST_FROM_TREET',
  Search = 'SEARCH',
  TradeInUpload = 'TRADE_IN_UPLOAD',
  Unknown = 'UNKNOWN',
  Upload = 'UPLOAD',
}

export type Fulfillment = {
  bundle?: Maybe<Bundle>;
  createdAt: Scalars['DateTime'];
  deliveredAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isBrandFulfilled?: Maybe<Scalars['Boolean']>;
  labelURL?: Maybe<Scalars['String']>;
  method?: Maybe<FulfillmentMethod>;
  returnBundle?: Maybe<Bundle>;
  shippingLabelProvider?: Maybe<ShippingLabelProvider>;
  shippoObjectId?: Maybe<Scalars['String']>;
  trackingNumber: Scalars['String'];
  trackingURL: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  weight: Scalars['Float'];
  weightUnit: WeightUnit;
};

export enum FulfillmentMethod {
  PartnerShopify = 'PARTNER_SHOPIFY',
  Peer = 'PEER',
  RetailReworks = 'RETAIL_REWORKS',
  Shopify = 'SHOPIFY',
  Treet = 'TREET',
}

export enum ItemStatus {
  Canceled = 'CANCELED',
  DisputeAccepted = 'DISPUTE_ACCEPTED',
  DisputeOpen = 'DISPUTE_OPEN',
  DisputeResolved = 'DISPUTE_RESOLVED',
  PaidOut = 'PAID_OUT',
  Refunded = 'REFUNDED',
  RefundInitiated = 'REFUND_INITIATED',
  ReturnInitiated = 'RETURN_INITIATED',
  Verified = 'VERIFIED',
}

export type LineItem = {
  bundle?: Maybe<Bundle>;
  code: LineItemCode;
  createdAt: Scalars['DateTime'];
  discountLineItem?: Maybe<DiscountLineItem>;
  id: Scalars['ID'];
  includeFor: Array<Participant>;
  listingLineItem?: Maybe<ListingLineItem>;
  name: Scalars['String'];
  order: Order;
  returnInsuranceLineItem?: Maybe<ReturnInsuranceLineItem>;
  shippingLineItem?: Maybe<ShippingLineItem>;
  taxLineItem?: Maybe<TaxLineItem>;
  updatedAt: Scalars['DateTime'];
};

export enum LineItemCode {
  Discount = 'DISCOUNT',
  Listing = 'LISTING',
  ReturnInsurance = 'RETURN_INSURANCE',
  Shipping = 'SHIPPING',
  Tax = 'TAX',
}

export type Listing = {
  approvalMetadata?: Maybe<Scalars['Json']>;
  approvedAt?: Maybe<Scalars['DateTime']>;
  author?: Maybe<Scalars['Json']>;
  availableInventory?: Maybe<Scalars['Int']>;
  bundleItems: Array<BundleItem>;
  canRelist: Scalars['Boolean'];
  cartItems: Array<CartItem>;
  categories?: Maybe<Array<Maybe<Scalars['String']>>>;
  condition?: Maybe<ListingCondition>;
  createdAt: Scalars['DateTime'];
  createdListings: Array<Listing>;
  creditBoostPromoId?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  /** Sourced from Shopify Product Variant */
  externalSku?: Maybe<Scalars['String']>;
  favoritedItems: Array<FavoritedItem>;
  findItemMethod?: Maybe<FindItemMethod>;
  id: Scalars['ID'];
  internalNotes?: Maybe<Scalars['String']>;
  isBrandDirect?: Maybe<Scalars['Boolean']>;
  isReturnable?: Maybe<Scalars['Boolean']>;
  /** Brand of item if it differs from shop's brand */
  itemBrand?: Maybe<Scalars['String']>;
  itemType?: Maybe<ListingItemType>;
  lastPurchaseBundleId?: Maybe<Scalars['String']>;
  lastSoldAt?: Maybe<Scalars['DateTime']>;
  listingFeedback: Array<ListingFeedback>;
  listingLineItems: Array<ListingLineItem>;
  listingMedia?: Maybe<Scalars['Json']>;
  notes?: Maybe<Scalars['String']>;
  originalPrice?: Maybe<Scalars['Int']>;
  partnerData?: Maybe<PartnerData>;
  payoutInfo?: Maybe<Scalars['Json']>;
  price?: Maybe<Scalars['Int']>;
  priceDropConfig?: Maybe<PriceDropConfig>;
  privateSellerNotes?: Maybe<Scalars['String']>;
  product?: Maybe<Product>;
  productHtml?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  productVariant?: Maybe<ProductVariant>;
  productVariantId?: Maybe<Scalars['String']>;
  promosActive?: Maybe<Array<Maybe<Scalars['String']>>>;
  quirks?: Maybe<Array<Maybe<Scalars['String']>>>;
  selectedVariantOptions?: Maybe<Scalars['Json']>;
  seller: User;
  sellerId: Scalars['String'];
  sharetribeListingId: Scalars['String'];
  sharetribePublicData?: Maybe<Scalars['Json']>;
  shipFromCountry?: Maybe<CountryCode>;
  shop: Shop;
  shopId: Scalars['String'];
  sourceListing?: Maybe<Listing>;
  sourceListingId?: Maybe<Scalars['String']>;
  state?: Maybe<ListingState>;
  syncShopifyInventory?: Maybe<Scalars['Boolean']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  upload?: Maybe<Upload>;
  uploadId?: Maybe<Scalars['String']>;
  wasCanceled: Scalars['Boolean'];
  weight?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<WeightUnit>;
};

export enum ListingCondition {
  Excellent = 'EXCELLENT',
  Good = 'GOOD',
  MinorDefect = 'MINOR_DEFECT',
  NewWithoutTags = 'NEW_WITHOUT_TAGS',
  NewWithTags = 'NEW_WITH_TAGS',
}

export type ListingFeedback = {
  /** Corresponds to the feedback categories displayed in the frontend. */
  category: Scalars['String'];
  createdAt: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  feedbackAuthor?: Maybe<User>;
  id: Scalars['ID'];
  listing?: Maybe<Listing>;
  note?: Maybe<Scalars['String']>;
  sharetribeListingId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type ListingFeedbackPayload = {
  listingFeedback: ListingFeedback;
};

export enum ListingItemType {
  Marketplace = 'MARKETPLACE',
  TradeIn = 'TRADE_IN',
}

export type ListingLineItem = {
  createdAt: Scalars['DateTime'];
  currency: Currency;
  id: Scalars['ID'];
  lineItem: LineItem;
  price: Scalars['Int'];
  quantity: Scalars['Int'];
  sharetribeListingId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type ListingMedia = {
  createdAt: Scalars['DateTime'];
  isRelisted: Scalars['Boolean'];
  listingId: Scalars['String'];
  media: Media;
  mediaId: Scalars['String'];
  orderIndex: Scalars['Int'];
  type: MediaType;
  updatedAt: Scalars['DateTime'];
};

export type ListingPayload = {
  listing: Listing;
};

export enum ListingState {
  Closed = 'CLOSED',
  Deleted = 'DELETED',
  Open = 'OPEN',
  PendingApproval = 'PENDING_APPROVAL',
  PendingBrandApproval = 'PENDING_BRAND_APPROVAL',
}

export type ListingsInput = {
  authorId?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  isAvailable?: InputMaybe<Scalars['Boolean']>;
  isPurchased?: InputMaybe<Scalars['Boolean']>;
  itemType?: InputMaybe<ListingItemType>;
  sharetribeListingIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  shop?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['String']>;
};

export enum Locale {
  DeDe = 'DE_DE',
  EnAu = 'EN_AU',
  EnCa = 'EN_CA',
  EnGb = 'EN_GB',
  EnNl = 'EN_NL',
  EnUs = 'EN_US',
  EsEs = 'ES_ES',
  FrCa = 'FR_CA',
  FrFr = 'FR_FR',
  ItIt = 'IT_IT',
  NlNl = 'NL_NL',
}

export type Media = {
  cdnUrl: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  listingsMedia: Array<ListingMedia>;
  metadata: Scalars['Json'];
  mimeType: Scalars['String'];
  source: MediaSource;
  updatedAt: Scalars['DateTime'];
};

export type MediaPayload = {
  media: Media;
};

export enum MediaSource {
  Custom = 'CUSTOM',
  Magento = 'MAGENTO',
  Shopify = 'SHOPIFY',
  Uploadcare = 'UPLOADCARE',
}

export enum MediaType {
  Seller = 'SELLER',
  Stock = 'STOCK',
}

export type MinimalDraftListing = {
  id: Scalars['ID'];
  sellerPhotos: Array<Scalars['Json']>;
};

export type Mutation = {
  addShipFromAddressToBundle: BundlePayload;
  adminUpdateBundle: BundlePayload;
  createCancellation: CancellationPayload;
  createCartItem: Array<CartItem>;
  createFavoritedItem: FavoritedItemPayload;
  createFulfillment: Fulfillment;
  createFulfillmentFromTrackingInfo: Fulfillment;
  createListingFeedback: ListingFeedbackPayload;
  createUser: UserPayload;
  deleteDraftListing: DraftListing;
  extendBundleShipping: BundlePayload;
  extendDisputesExpirationDate: DisputesPayload;
  publishDraftListing: DraftListing;
  removeCartItem: Array<CartItem>;
  removeFavoritedItem: FavoritedItemPayload;
  saveShopIntegrationConfig?: Maybe<ShopIntegrationSavePayload>;
  transitionBundleItemToCanceled: BundleItemPayload;
  transitionBundleItemToDisputeAccepted: BundleItemPayload;
  transitionBundleItemToDisputeRejected: BundleItemPayload;
  transitionBundleItemToPaidOut: BundleItemPayload;
  transitionBundleItemToRefunded: BundleItemPayload;
  transitionBundleItemToVerified: BundleItemPayload;
  transitionBundleToDelivered: BundlePayload;
  transitionBundleToShipped: BundlePayload;
  updateAddress: AddressPayload;
  updateBundle: BundlePayload;
  updateBundleItem: BundleItemPayload;
  updateUser: UserPayload;
  updateUserShipFromCountry: UpdateUserShipFromCountryPayload;
  upsertDispute: DisputePayload;
  upsertDraftListing: DraftListing;
  upsertGeneralSavedSearch: SavedSearchPayload;
  upsertISOSavedSearch: SavedSearchPayload;
  upsertListing: ListingPayload;
  upsertPhotosOnDraft: MinimalDraftListing;
  upsertPriceDropConfig: PriceDropConfigPayload;
  verifyBundle: BundlePayload;
};

export type MutationAddShipFromAddressToBundleArgs = {
  input: AddShipFromAddressInput;
};

export type MutationAdminUpdateBundleArgs = {
  input: AdminUpdateBundleInput;
};

export type MutationCreateCancellationArgs = {
  input: CreateCancellationInput;
};

export type MutationCreateCartItemArgs = {
  input: CreateCartItemInput;
};

export type MutationCreateFavoritedItemArgs = {
  input: CreateFavoritedItemInput;
};

export type MutationCreateFulfillmentArgs = {
  input: CreateFulfillmentInput;
};

export type MutationCreateFulfillmentFromTrackingInfoArgs = {
  input: CreateFulfillmentFromTrackingInfoInput;
};

export type MutationCreateListingFeedbackArgs = {
  input: CreateListingFeedbackInput;
};

export type MutationCreateUserArgs = {
  input: CreateUserInput;
};

export type MutationDeleteDraftListingArgs = {
  input: DraftListingInput;
};

export type MutationExtendBundleShippingArgs = {
  input: ExtendBundleShippingInput;
};

export type MutationExtendDisputesExpirationDateArgs = {
  input: ExtendDisputesExpirationDateInput;
};

export type MutationPublishDraftListingArgs = {
  input: DraftListingInput;
};

export type MutationRemoveCartItemArgs = {
  input: RemoveCartItemsInput;
};

export type MutationRemoveFavoritedItemArgs = {
  input: RemoveFavoritedItemInput;
};

export type MutationSaveShopIntegrationConfigArgs = {
  input: ShopIntegrationSaveInput;
};

export type MutationTransitionBundleItemToCanceledArgs = {
  input: TransitionBundleItemToCanceledInput;
};

export type MutationTransitionBundleItemToDisputeAcceptedArgs = {
  input: TransitionDisputedBundleItemInput;
};

export type MutationTransitionBundleItemToDisputeRejectedArgs = {
  input: TransitionDisputedBundleItemInput;
};

export type MutationTransitionBundleItemToPaidOutArgs = {
  input: TransitionBundleItemToPaidOutInput;
};

export type MutationTransitionBundleItemToRefundedArgs = {
  input: TransitionBundleItemToRefundedInput;
};

export type MutationTransitionBundleItemToVerifiedArgs = {
  input: TransitionBundleItemToVerifiedInput;
};

export type MutationTransitionBundleToDeliveredArgs = {
  input: TransitionBundleInput;
};

export type MutationTransitionBundleToShippedArgs = {
  input: TransitionBundleInput;
};

export type MutationUpdateAddressArgs = {
  input: UpdateAddressInput;
};

export type MutationUpdateBundleArgs = {
  input: UpdateBundleInput;
};

export type MutationUpdateBundleItemArgs = {
  input: UpdateBundleItemInput;
};

export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};

export type MutationUpdateUserShipFromCountryArgs = {
  input: UpdateUserShipFromCountryInput;
};

export type MutationUpsertDisputeArgs = {
  input: UpsertDisputeInput;
};

export type MutationUpsertDraftListingArgs = {
  input: UpsertDraftListingInput;
};

export type MutationUpsertGeneralSavedSearchArgs = {
  input: UpsertGeneralSavedSearchInput;
};

export type MutationUpsertIsoSavedSearchArgs = {
  input: UpsertIsoSavedSearchInput;
};

export type MutationUpsertListingArgs = {
  input: UpsertListingInput;
};

export type MutationUpsertPhotosOnDraftArgs = {
  draftListingId: Scalars['ID'];
  sellerPhotos: Array<Scalars['Json']>;
};

export type MutationUpsertPriceDropConfigArgs = {
  input: UpsertPriceDropConfigInput;
};

export type MutationVerifyBundleArgs = {
  input: TransitionBundleInput;
};

export type Order = {
  billingAddress?: Maybe<Address>;
  bundles: Array<Bundle>;
  buyer?: Maybe<User>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  lineItems: Array<LineItem>;
  sharetribeBuyerId: Scalars['String'];
  shippingAddress: Address;
  updatedAt: Scalars['DateTime'];
};

export type OrderProduct = {
  orderDate: Scalars['String'];
  orderNumber: Scalars['String'];
  products: Array<ProductForOrder>;
};

export type OrderProductList = {
  orderProducts: Array<OrderProduct>;
  pageInfo: PageInfo;
};

/** Pagination metadata */
export type PageInfo = {
  endCursor?: Maybe<Scalars['String']>;
  hasNext: Scalars['Boolean'];
  take: Scalars['Int'];
};

export enum Participant {
  Brand = 'BRAND',
  Buyer = 'BUYER',
  Seller = 'SELLER',
}

export type PartnerData = {
  apiMetadata?: Maybe<Scalars['Json']>;
  createdAt: Scalars['DateTime'];
  externalIdentifier?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  listing: Listing;
  listingId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export enum PaymentMethod {
  ApplePay = 'APPLE_PAY',
  Card = 'CARD',
  GooglePay = 'GOOGLE_PAY',
}

export enum PayoutType {
  Cash = 'CASH',
  Credit = 'CREDIT',
}

export type PriceDropConfig = {
  anchorPrice: Scalars['Int'];
  daysBetweenPriceDrops: Scalars['Int'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  listingId: Scalars['String'];
  minPrice: Scalars['Int'];
  nextScheduledDrop?: Maybe<Scalars['DateTime']>;
  percentageDrop: Scalars['Int'];
};

export type PriceDropConfigPayload = {
  priceDropConfig: PriceDropConfig;
};

export type Product = {
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  externalProductId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  listing: Array<Listing>;
  productMedia: Array<ProductMedia>;
  productType?: Maybe<Scalars['String']>;
  productVariants: Array<ProductVariant>;
  shop: Shop;
  shopId: Scalars['String'];
  tags: Array<Scalars['String']>;
  title: Scalars['String'];
  type: ProductType;
  updatedAt: Scalars['DateTime'];
};

export type ProductForOrder = {
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  productMedia?: Maybe<Array<Maybe<ProductMedia>>>;
  productType?: Maybe<Scalars['String']>;
  productVariant?: Maybe<ProductVariantForOrder>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  title: Scalars['String'];
};

export type ProductList = {
  pageInfo: PageInfo;
  products: Array<Product>;
};

export type ProductMedia = {
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  media: Media;
  mediaId: Scalars['String'];
  orderIndex: Scalars['Int'];
  product?: Maybe<Product>;
  productId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type ProductMediaPayload = {
  productMedia: ProductMedia;
};

export enum ProductType {
  Custom = 'CUSTOM',
  External = 'EXTERNAL',
}

export type ProductVariant = {
  barcode?: Maybe<Scalars['String']>;
  compareAtPrice?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  currency?: Maybe<Currency>;
  externalProductVariantId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  listing: Array<Listing>;
  price?: Maybe<Scalars['Int']>;
  product: Product;
  productId: Scalars['String'];
  productMedia: Array<ProductMedia>;
  selectedVariantOptions?: Maybe<Scalars['Json']>;
  shop: Shop;
  shopId: Scalars['String'];
  sku?: Maybe<Scalars['String']>;
  type: ProductVariantType;
  updatedAt: Scalars['DateTime'];
  weight?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<WeightUnit>;
};

export type ProductVariantForOrder = {
  barcode?: Maybe<Scalars['String']>;
  compareAtPrice?: Maybe<Scalars['Int']>;
  currency?: Maybe<Currency>;
  id: Scalars['ID'];
  price?: Maybe<Scalars['Int']>;
  productMedia?: Maybe<Array<Maybe<ProductMedia>>>;
  selectedVariantOptions?: Maybe<Scalars['Json']>;
  sku?: Maybe<Scalars['String']>;
  weight?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<WeightUnit>;
};

export enum ProductVariantType {
  Custom = 'CUSTOM',
  External = 'EXTERNAL',
}

export type Query = {
  brandDisbursements: Array<Disbursement>;
  brandHealthAction?: Maybe<BrandHealthAction>;
  brandHealthActions: Array<BrandHealthAction>;
  brandHealthLog?: Maybe<BrandHealthLog>;
  brandReports: Array<Disbursement>;
  bundle?: Maybe<Bundle>;
  bundles: Array<Bundle>;
  cartItems: Array<CartItem>;
  couriers: Array<Courier>;
  currentUser?: Maybe<CurrentUser>;
  disbursement?: Maybe<Disbursement>;
  draftListing: DraftListing;
  draftListings: Array<DraftListing>;
  favoritedItems: Array<FavoritedItemQueryPayload>;
  getOrderProducts: OrderProductList;
  isoSavedSearches: Array<SavedSearch>;
  listings: Array<Listing>;
  order?: Maybe<Order>;
  orders: Array<Order>;
  priceDropConfig?: Maybe<PriceDropConfig>;
  products: ProductList;
  savedSearch?: Maybe<SavedSearch>;
  shop?: Maybe<Shop>;
  shopAlloyToken?: Maybe<Scalars['String']>;
  shopByHostname?: Maybe<Shop>;
  shopIntegration?: Maybe<ShopIntegration>;
  shopIntegrations: Array<ShopIntegration>;
};

export type QueryBrandDisbursementsArgs = {
  offset?: InputMaybe<Scalars['Int']>;
  shopId: Scalars['String'];
};

export type QueryBrandHealthActionArgs = {
  key: Scalars['String'];
};

export type QueryBrandHealthLogArgs = {
  shopId: Scalars['String'];
};

export type QueryBrandReportsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  shopId: Scalars['String'];
};

export type QueryBundleArgs = {
  id: Scalars['String'];
};

export type QueryBundlesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  searchQuery?: InputMaybe<Scalars['String']>;
  sharetribeListingIds?: InputMaybe<Array<Scalars['String']>>;
  sharetribeSellerId: Scalars['String'];
  shopName?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<BundleStatus>;
};

export type QueryDisbursementArgs = {
  id: Scalars['String'];
};

export type QueryDraftListingArgs = {
  input?: InputMaybe<DraftListingInput>;
};

export type QueryDraftListingsArgs = {
  input?: InputMaybe<DraftListingFilterInput>;
};

export type QueryFavoritedItemsArgs = {
  treetId: Scalars['String'];
};

export type QueryGetOrderProductsArgs = {
  countryCode: Scalars['String'];
  cursor?: InputMaybe<Scalars['String']>;
  treetId: Scalars['String'];
};

export type QueryIsoSavedSearchesArgs = {
  email: Scalars['String'];
  treetId: Scalars['String'];
};

export type QueryListingsArgs = {
  input?: InputMaybe<ListingsInput>;
};

export type QueryOrderArgs = {
  id: Scalars['String'];
};

export type QueryOrdersArgs = {
  bundleStatus?: InputMaybe<BundleStatus>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  searchQuery?: InputMaybe<Scalars['String']>;
  sharetribeBuyerId: Scalars['String'];
  shopName?: InputMaybe<Scalars['String']>;
};

export type QueryPriceDropConfigArgs = {
  isActive?: InputMaybe<Scalars['Boolean']>;
  listingId?: InputMaybe<Scalars['ID']>;
  sharetribeListingId?: InputMaybe<Scalars['ID']>;
};

export type QueryProductsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  productType?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  shopId: Scalars['String'];
  take?: InputMaybe<Scalars['Int']>;
};

export type QuerySavedSearchArgs = {
  email: Scalars['String'];
  treetId: Scalars['String'];
  type?: InputMaybe<SavedSearchType>;
};

export type QueryShopArgs = {
  treetId: Scalars['String'];
};

export type QueryShopAlloyTokenArgs = {
  shopId: Scalars['String'];
};

export type QueryShopByHostnameArgs = {
  hostname: Scalars['String'];
};

export type QueryShopIntegrationArgs = {
  integrationType: ShopIntegrationType;
  shopId: Scalars['String'];
};

export type QueryShopIntegrationsArgs = {
  shopId: Scalars['String'];
  showHidden?: InputMaybe<Scalars['Boolean']>;
};

export type Refund = {
  bundle: Bundle;
  createdAt: Scalars['DateTime'];
  currency: Currency;
  id: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  price: Scalars['Int'];
  refundedLineItems: Array<LineItem>;
  type: RefundType;
  updatedAt: Scalars['DateTime'];
};

export type RefundPayload = {
  refund: Refund;
};

export enum RefundType {
  Cancellation = 'CANCELLATION',
  Dispute = 'DISPUTE',
}

export type RemoveCartItemsInput = {
  sharetribeListingIds: Array<Scalars['String']>;
};

export type RemoveFavoritedItemInput = {
  sharetribeListingId: Scalars['String'];
};

export type ReturnInsuranceLineItem = {
  createdAt: Scalars['DateTime'];
  currency: Currency;
  id: Scalars['ID'];
  lineItem: LineItem;
  price: Scalars['Int'];
  provider: ReturnInsuranceProvider;
  /** For Seel, this is the policy ID */
  providerId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export enum ReturnInsuranceProvider {
  Seel = 'SEEL',
}

export type SavedSearch = {
  cadence: Cadence;
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  id: Scalars['ID'];
  search: Scalars['Json'];
  shop: Shop;
  /** Email Sign Up Attribution */
  subscribeSource: EmailSubscribeSource;
  type: SavedSearchType;
  updatedAt: Scalars['DateTime'];
};

export type SavedSearchPayload = {
  metadata?: Maybe<SavedSearchPayloadMetadata>;
  savedSearch: SavedSearch;
};

export type SavedSearchPayloadMetadata = {
  created?: Maybe<Scalars['Boolean']>;
  updated?: Maybe<Scalars['Boolean']>;
};

export enum SavedSearchType {
  General = 'GENERAL',
  InSearchOf = 'IN_SEARCH_OF',
}

export enum ShippingLabelProvider {
  Aftership = 'AFTERSHIP',
  Shipstation = 'SHIPSTATION',
  Shopify = 'SHOPIFY',
  SuperCircle = 'SUPER_CIRCLE',
  Treet = 'TREET',
}

export type ShippingLineItem = {
  createdAt: Scalars['DateTime'];
  currency: Currency;
  id: Scalars['ID'];
  lineItem: LineItem;
  price: Scalars['Int'];
  quantity: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type Shop = {
  brandName: Scalars['String'];
  canonicalRootUrl: Scalars['String'];
  createdAt: Scalars['DateTime'];
  /** Currency of the brand's Shopify account. */
  defaultCurrency?: Maybe<Currency>;
  hostname: Scalars['String'];
  id: Scalars['ID'];
  loyaltyProgram?: Maybe<ShopLoyaltyProgram>;
  primaryLocale: Locale;
  savedSearches: Array<SavedSearch>;
  treetId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type ShopIntegration = {
  configuration?: Maybe<ShopIntegrationConfig>;
  description: Scalars['String'];
  detailedDescription?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  integration?: Maybe<AlloyIntegration>;
  integrationId?: Maybe<Scalars['String']>;
  integrationTarget: ShopIntegrationTarget;
  integrationType: Scalars['String'];
  shop?: Maybe<Shop>;
  shopId: Scalars['String'];
  subtitle: Scalars['String'];
  tags?: Maybe<Array<ShopIntegrationTag>>;
  tier: Scalars['String'];
  title: Scalars['String'];
};

export type ShopIntegrationConfig = {
  configuration: Scalars['Json'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  integrationType: ShopIntegrationType;
  isActive: Scalars['Boolean'];
  shopId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type ShopIntegrationSaveConfigError = {
  key: Scalars['String'];
  reason: Scalars['String'];
};

export enum ShopIntegrationSaveConfigErrorReason {
  SettingInvalidDefault = 'SETTING_INVALID_DEFAULT',
  SettingMissingDefault = 'SETTING_MISSING_DEFAULT',
  SettingTypeMismatch = 'SETTING_TYPE_MISMATCH',
  SettingUnknown = 'SETTING_UNKNOWN',
  ValueIsInvalid = 'VALUE_IS_INVALID',
  ValueIsRequired = 'VALUE_IS_REQUIRED',
}

export type ShopIntegrationSaveInput = {
  configuration: Scalars['Json'];
  integrationType: ShopIntegrationType;
  isActive: Scalars['Boolean'];
  shopId: Scalars['String'];
};

export type ShopIntegrationSavePayload = {
  configuration?: Maybe<ShopIntegrationConfig>;
  validationErrors: Array<Maybe<ShopIntegrationSaveConfigError>>;
};

export type ShopIntegrationTag = {
  key: Scalars['String'];
  title: Scalars['String'];
};

export type ShopIntegrationTarget = {
  applicationUrl?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  iconUrl?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  treetSupportArticleUrl?: Maybe<Scalars['String']>;
};

/** Enum for different types of integrations configurable for shops.\n\nFormat is the vendor name + the type of functionality it fulfills (e.g. Rewards\npowered by LoyaltyLion = LOYALTYLION_REWARDS) */
export enum ShopIntegrationType {
  FillogicReturns = 'FILLOGIC_RETURNS',
  GivexCredit = 'GIVEX_CREDIT',
  HappyreturnsReturns = 'HAPPYRETURNS_RETURNS',
  KlaviyoCustomerSegmentation = 'KLAVIYO_CUSTOMER_SEGMENTATION',
  KlaviyoEmailCustomization = 'KLAVIYO_EMAIL_CUSTOMIZATION',
  LoopReturns = 'LOOP_RETURNS',
  LoyaltylionRewards = 'LOYALTYLION_REWARDS',
  RiseaiCredit = 'RISEAI_CREDIT',
  ShopifyCustomerSegmentation = 'SHOPIFY_CUSTOMER_SEGMENTATION',
  YotpoRewards = 'YOTPO_REWARDS',
}

export type ShopLoyaltyProgram = {
  pointsName: Scalars['String'];
  pointsPerMoneyUnit: Scalars['Float'];
  programName: Scalars['String'];
  programUrl: Scalars['String'];
};

export type TaxLineItem = {
  createdAt: Scalars['DateTime'];
  currency: Currency;
  id: Scalars['ID'];
  metadata: Scalars['Json'];
  rate: Scalars['Float'];
  taxCode: Scalars['String'];
  taxId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  value: Scalars['Float'];
};

export type TransitionBundleInput = {
  id: Scalars['ID'];
};

export type TransitionBundleItemToCanceledInput = {
  bundleItemId: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  reason: CancelReason;
};

export type TransitionBundleItemToPaidOutInput = {
  bundleItemId: Scalars['String'];
  type: PayoutType;
};

export type TransitionBundleItemToRefundedInput = {
  bundleItemId: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  type: RefundType;
};

export type TransitionBundleItemToVerifiedInput = {
  id: Scalars['ID'];
};

export type TransitionDisputedBundleItemInput = {
  id: Scalars['ID'];
};

export type UpdateAddressInput = {
  addressLine1: Scalars['String'];
  addressLine2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  fullName: Scalars['String'];
  id: Scalars['ID'];
  state: Scalars['String'];
  zip: Scalars['String'];
};

export type UpdateBundleInput = {
  canceledAt?: InputMaybe<Scalars['DateTime']>;
  expireAt?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isMarkedFulfilled?: InputMaybe<Scalars['Boolean']>;
  payoutOption?: InputMaybe<PayoutType>;
  status?: InputMaybe<BundleStatus>;
};

export type UpdateBundleItemInput = {
  id: Scalars['ID'];
  status: ItemStatus;
};

export type UpdateUserInput = {
  email: Scalars['String'];
  newEmail?: InputMaybe<Scalars['String']>;
  stripeAccountId?: InputMaybe<Scalars['String']>;
};

export type UpdateUserShipFromCountryInput = {
  shipFromCountry: CountryCode;
};

export type UpdateUserShipFromCountryPayload = {
  shipFromCountry?: Maybe<CountryCode>;
};

export type Upload = {
  id: Scalars['ID'];
  listings: Array<Listing>;
  type: UploadType;
  uploadId: Scalars['String'];
};

export enum UploadType {
  CrossPost = 'CROSS_POST',
  Duplicate = 'DUPLICATE',
  Manual = 'MANUAL',
  Transfer = 'TRANSFER',
}

export type UpsertDisputeInput = {
  bundleId: Scalars['String'];
  bundleItemId: Scalars['String'];
  itemStatus?: InputMaybe<ItemStatus>;
  note?: InputMaybe<Scalars['String']>;
  reason: DisputeReason;
  status: DisputeStatus;
};

export type UpsertDraftListingInput = {
  categories: Array<Scalars['String']>;
  condition?: InputMaybe<ListingCondition>;
  currency?: InputMaybe<Currency>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  findItemMethod?: InputMaybe<FindItemMethod>;
  id?: InputMaybe<Scalars['ID']>;
  itemBrand?: InputMaybe<Scalars['String']>;
  itemType?: InputMaybe<ListingItemType>;
  listingFlowMetadata?: InputMaybe<Scalars['Json']>;
  notes?: InputMaybe<Scalars['String']>;
  originalPrice?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['Int']>;
  priceDropConfigJson?: InputMaybe<Scalars['Json']>;
  privateSellerNotes?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['String']>;
  productVariantId?: InputMaybe<Scalars['String']>;
  publishedListingId?: InputMaybe<Scalars['String']>;
  quirks: Array<Scalars['String']>;
  selectedVariantOptions?: InputMaybe<Scalars['Json']>;
  sellerId?: InputMaybe<Scalars['String']>;
  sellerPhotos: Array<Scalars['Json']>;
  sharetribeListingId?: InputMaybe<Scalars['String']>;
  shopId: Scalars['String'];
  sourceListingId?: InputMaybe<Scalars['String']>;
  state: DraftListingState;
  stockPhotoUrls: Array<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type UpsertGeneralSavedSearchInput = {
  cadence: Cadence;
  email: Scalars['String'];
  search: Scalars['Json'];
  shopId: Scalars['String'];
  /** Email Sign Up Attribution */
  subscribeSource: EmailSubscribeSource;
};

export type UpsertIsoSavedSearchInput = {
  cadence: Cadence;
  email: Scalars['String'];
  search: Scalars['Json'];
  shopId: Scalars['String'];
  /** Email Sign Up Attribution */
  subscribeSource: EmailSubscribeSource;
};

export type UpsertListingInput = {
  currency: Currency;
  itemType?: InputMaybe<ListingItemType>;
  price: Scalars['Int'];
  sharetribeListingId: Scalars['String'];
  sharetribeSellerId: Scalars['String'];
  sharetribeSourceListingId?: InputMaybe<Scalars['String']>;
  shopId: Scalars['String'];
  title: Scalars['String'];
};

export type UpsertPriceDropConfigInput = {
  anchorPrice: Scalars['Int'];
  daysBetweenPriceDrops: Scalars['Int'];
  isActive: Scalars['Boolean'];
  listingId: Scalars['String'];
  minPrice: Scalars['Int'];
  nextScheduledDrop?: InputMaybe<Scalars['DateTime']>;
  percentageDrop: Scalars['Int'];
};

export type User = {
  createdAt: Scalars['DateTime'];
  createdFromShop: Shop;
  displayName: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  sharetribeUserId: Scalars['String'];
  stripeAccountId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type UserPayload = {
  user: User;
};

export enum WeightUnit {
  G = 'G',
  Oz = 'OZ',
}

export type CoreAddress = {
  id: string;
  addressLine1: string;
  addressLine2?: string | null;
  city: string;
  state: string;
  country: string;
  zip: string;
  fullName: string;
  phone?: string | null;
};

export type CoreBundle = {
  id: string;
  createdAt: any;
  expireAt?: any | null;
  sharetribeTransactionIds: Array<string>;
  status: BundleStatus;
  isMarkedFulfilled?: boolean | null;
  type?: BundleType | null;
  isBrandDirect: boolean;
  isReturnable?: boolean | null;
  payoutOption?: PayoutType | null;
  shopifyOrderId?: string | null;
  refunds: Array<{
    id: string;
    currency: Currency;
    price: number;
    type: RefundType;
    refundedLineItems: Array<{ id: string }>;
  }>;
  lineItems: Array<{
    id: string;
    name: string;
    code: LineItemCode;
    includeFor: Array<Participant>;
    listingLineItem?: {
      id: string;
      currency: Currency;
      price: number;
      quantity: number;
      sharetribeListingId: string;
    } | null;
    shippingLineItem?: { id: string; currency: Currency; price: number; quantity: number } | null;
    discountLineItem?: {
      id: string;
      title: string;
      currency: Currency;
      value: number;
      valueType: DiscountValueType;
      target: DiscountTarget;
      metadata: any;
    } | null;
    returnInsuranceLineItem?: {
      id: string;
      currency: Currency;
      price: number;
      provider: ReturnInsuranceProvider;
      providerId: string;
    } | null;
    taxLineItem?: {
      id: string;
      taxId: string;
      taxCode: string;
      currency: Currency;
      value: number;
      rate: number;
      metadata: any;
    } | null;
  }>;
  fulfillment?: {
    id: string;
    trackingURL: string;
    trackingNumber: string;
    labelURL?: string | null;
    weightUnit: WeightUnit;
    weight: number;
    shippingLabelProvider?: ShippingLabelProvider | null;
    deliveredAt?: any | null;
  } | null;
  returnFulfillment?: {
    id: string;
    trackingURL: string;
    trackingNumber: string;
    labelURL?: string | null;
    weightUnit: WeightUnit;
    weight: number;
    shippingLabelProvider?: ShippingLabelProvider | null;
    deliveredAt?: any | null;
  } | null;
  bundleItems: Array<{
    id: string;
    status?: ItemStatus | null;
    historicalStatuses: Array<BundleItemHistoricalStatus>;
    dispute?: { id: string; reason: DisputeReason; note?: string | null } | null;
    listing: { id: string; sharetribeListingId: string };
  }>;
  order: {
    id: string;
    sharetribeBuyerId: string;
    buyer?: { id: string; displayName: string } | null;
  };
};

export type CoreBundleItem = {
  id: string;
  status?: ItemStatus | null;
  historicalStatuses: Array<BundleItemHistoricalStatus>;
  dispute?: { id: string; reason: DisputeReason; note?: string | null } | null;
  listing: { id: string; sharetribeListingId: string };
};

export type CoreDisbursement = {
  id: string;
  startDate: any;
  endDate: any;
  earningsTotal: number;
  currency: Currency;
  status: DisbursementStatus;
};

export type CoreDiscountLineItem = {
  id: string;
  title: string;
  currency: Currency;
  value: number;
  valueType: DiscountValueType;
  target: DiscountTarget;
  metadata: any;
};

export type CoreDraftListing = {
  id: string;
  createdAt: any;
  updatedAt: any;
  state: DraftListingState;
  sharetribeListingId?: string | null;
  title?: string | null;
  price?: number | null;
  currency?: Currency | null;
  findItemMethod?: FindItemMethod | null;
  itemBrand?: string | null;
  itemType?: ListingItemType | null;
  categories: Array<string>;
  privateSellerNotes?: string | null;
  condition?: ListingCondition | null;
  notes?: string | null;
  originalPrice?: number | null;
  quirks: Array<string>;
  selectedVariantOptions?: any | null;
  sellerPhotos: Array<any>;
  stockPhotoUrls: Array<string>;
  priceDropConfigJson?: any | null;
  shopId: string;
  sellerId?: string | null;
  publishedListingId?: string | null;
  productId?: string | null;
  listingFlowMetadata?: any | null;
  sourceListingId?: string | null;
  product?: {
    id: string;
    createdAt: any;
    updatedAt: any;
    title: string;
    type: ProductType;
    productType?: string | null;
    shopId: string;
    description?: string | null;
    tags: Array<string>;
    productMedia: Array<{ orderIndex: number; media: { cdnUrl: string } }>;
    productVariants: Array<{
      id: string;
      createdAt: any;
      updatedAt: any;
      selectedVariantOptions?: any | null;
      price?: number | null;
      compareAtPrice?: number | null;
      sku?: string | null;
      weight?: number | null;
      weightUnit?: WeightUnit | null;
      barcode?: string | null;
      productMedia: Array<{ orderIndex: number; media: { cdnUrl: string } }>;
    }>;
  } | null;
  productVariant?: {
    id: string;
    createdAt: any;
    updatedAt: any;
    selectedVariantOptions?: any | null;
    price?: number | null;
    compareAtPrice?: number | null;
    sku?: string | null;
    weight?: number | null;
    weightUnit?: WeightUnit | null;
    barcode?: string | null;
    productMedia: Array<{ orderIndex: number; media: { cdnUrl: string } }>;
  } | null;
  publishedListing?: { title: string; sharetribeListingId: string } | null;
};

export type CoreFulfillment = {
  id: string;
  trackingURL: string;
  trackingNumber: string;
  labelURL?: string | null;
  weightUnit: WeightUnit;
  weight: number;
  shippingLabelProvider?: ShippingLabelProvider | null;
  deliveredAt?: any | null;
};

export type CoreLineItem = {
  id: string;
  name: string;
  code: LineItemCode;
  includeFor: Array<Participant>;
  listingLineItem?: {
    id: string;
    currency: Currency;
    price: number;
    quantity: number;
    sharetribeListingId: string;
  } | null;
  shippingLineItem?: { id: string; currency: Currency; price: number; quantity: number } | null;
  discountLineItem?: {
    id: string;
    title: string;
    currency: Currency;
    value: number;
    valueType: DiscountValueType;
    target: DiscountTarget;
    metadata: any;
  } | null;
  returnInsuranceLineItem?: {
    id: string;
    currency: Currency;
    price: number;
    provider: ReturnInsuranceProvider;
    providerId: string;
  } | null;
  taxLineItem?: {
    id: string;
    taxId: string;
    taxCode: string;
    currency: Currency;
    value: number;
    rate: number;
    metadata: any;
  } | null;
};

export type CoreListing = {
  id: string;
  createdAt: any;
  updatedAt: any;
  sharetribeListingId: string;
  title: string;
  price?: number | null;
  externalSku?: string | null;
  availableInventory?: number | null;
  state?: ListingState | null;
  currency?: string | null;
  shipFromCountry?: CountryCode | null;
  findItemMethod?: FindItemMethod | null;
  itemBrand?: string | null;
  sourceListingId?: string | null;
  isBrandDirect?: boolean | null;
  itemType?: ListingItemType | null;
  sharetribePublicData?: any | null;
  deletedAt?: any | null;
  categories?: Array<string | null> | null;
  condition?: ListingCondition | null;
  notes?: string | null;
  originalPrice?: number | null;
  productHtml?: string | null;
  quirks?: Array<string | null> | null;
  selectedVariantOptions?: any | null;
  tags?: Array<string | null> | null;
  promosActive?: Array<string | null> | null;
  syncShopifyInventory?: boolean | null;
  approvedAt?: any | null;
  lastSoldAt?: any | null;
  isReturnable?: boolean | null;
  weight?: number | null;
  weightUnit?: WeightUnit | null;
  author?: any | null;
  listingMedia?: any | null;
  product?: {
    id: string;
    createdAt: any;
    updatedAt: any;
    title: string;
    type: ProductType;
    productType?: string | null;
    shopId: string;
    description?: string | null;
    tags: Array<string>;
    productMedia: Array<{ orderIndex: number; media: { cdnUrl: string } }>;
    productVariants: Array<{
      id: string;
      createdAt: any;
      updatedAt: any;
      selectedVariantOptions?: any | null;
      price?: number | null;
      compareAtPrice?: number | null;
      sku?: string | null;
      weight?: number | null;
      weightUnit?: WeightUnit | null;
      barcode?: string | null;
      productMedia: Array<{ orderIndex: number; media: { cdnUrl: string } }>;
    }>;
  } | null;
  productVariant?: {
    id: string;
    createdAt: any;
    updatedAt: any;
    selectedVariantOptions?: any | null;
    price?: number | null;
    compareAtPrice?: number | null;
    sku?: string | null;
    weight?: number | null;
    weightUnit?: WeightUnit | null;
    barcode?: string | null;
    productMedia: Array<{ orderIndex: number; media: { cdnUrl: string } }>;
  } | null;
};

export type CoreListingLineItem = {
  id: string;
  currency: Currency;
  price: number;
  quantity: number;
  sharetribeListingId: string;
};

export type CoreOrder = {
  id: string;
  createdAt: any;
  shippingAddress: {
    id: string;
    addressLine1: string;
    addressLine2?: string | null;
    city: string;
    state: string;
    country: string;
    zip: string;
    fullName: string;
    phone?: string | null;
  };
  billingAddress?: {
    id: string;
    addressLine1: string;
    addressLine2?: string | null;
    city: string;
    state: string;
    country: string;
    zip: string;
    fullName: string;
    phone?: string | null;
  } | null;
  bundles: Array<{
    id: string;
    createdAt: any;
    expireAt?: any | null;
    sharetribeTransactionIds: Array<string>;
    status: BundleStatus;
    isMarkedFulfilled?: boolean | null;
    type?: BundleType | null;
    isBrandDirect: boolean;
    isReturnable?: boolean | null;
    payoutOption?: PayoutType | null;
    shopifyOrderId?: string | null;
    refunds: Array<{
      id: string;
      currency: Currency;
      price: number;
      type: RefundType;
      refundedLineItems: Array<{ id: string }>;
    }>;
    lineItems: Array<{
      id: string;
      name: string;
      code: LineItemCode;
      includeFor: Array<Participant>;
      listingLineItem?: {
        id: string;
        currency: Currency;
        price: number;
        quantity: number;
        sharetribeListingId: string;
      } | null;
      shippingLineItem?: { id: string; currency: Currency; price: number; quantity: number } | null;
      discountLineItem?: {
        id: string;
        title: string;
        currency: Currency;
        value: number;
        valueType: DiscountValueType;
        target: DiscountTarget;
        metadata: any;
      } | null;
      returnInsuranceLineItem?: {
        id: string;
        currency: Currency;
        price: number;
        provider: ReturnInsuranceProvider;
        providerId: string;
      } | null;
      taxLineItem?: {
        id: string;
        taxId: string;
        taxCode: string;
        currency: Currency;
        value: number;
        rate: number;
        metadata: any;
      } | null;
    }>;
    fulfillment?: {
      id: string;
      trackingURL: string;
      trackingNumber: string;
      labelURL?: string | null;
      weightUnit: WeightUnit;
      weight: number;
      shippingLabelProvider?: ShippingLabelProvider | null;
      deliveredAt?: any | null;
    } | null;
    returnFulfillment?: {
      id: string;
      trackingURL: string;
      trackingNumber: string;
      labelURL?: string | null;
      weightUnit: WeightUnit;
      weight: number;
      shippingLabelProvider?: ShippingLabelProvider | null;
      deliveredAt?: any | null;
    } | null;
    bundleItems: Array<{
      id: string;
      status?: ItemStatus | null;
      historicalStatuses: Array<BundleItemHistoricalStatus>;
      dispute?: { id: string; reason: DisputeReason; note?: string | null } | null;
      listing: { id: string; sharetribeListingId: string };
    }>;
    order: {
      id: string;
      sharetribeBuyerId: string;
      buyer?: { id: string; displayName: string } | null;
    };
  }>;
  lineItems: Array<{
    id: string;
    name: string;
    code: LineItemCode;
    includeFor: Array<Participant>;
    listingLineItem?: {
      id: string;
      currency: Currency;
      price: number;
      quantity: number;
      sharetribeListingId: string;
    } | null;
    shippingLineItem?: { id: string; currency: Currency; price: number; quantity: number } | null;
    discountLineItem?: {
      id: string;
      title: string;
      currency: Currency;
      value: number;
      valueType: DiscountValueType;
      target: DiscountTarget;
      metadata: any;
    } | null;
    returnInsuranceLineItem?: {
      id: string;
      currency: Currency;
      price: number;
      provider: ReturnInsuranceProvider;
      providerId: string;
    } | null;
    taxLineItem?: {
      id: string;
      taxId: string;
      taxCode: string;
      currency: Currency;
      value: number;
      rate: number;
      metadata: any;
    } | null;
  }>;
};

export type CoreProduct = {
  id: string;
  createdAt: any;
  updatedAt: any;
  title: string;
  type: ProductType;
  productType?: string | null;
  shopId: string;
  description?: string | null;
  tags: Array<string>;
  productMedia: Array<{ orderIndex: number; media: { cdnUrl: string } }>;
  productVariants: Array<{
    id: string;
    createdAt: any;
    updatedAt: any;
    selectedVariantOptions?: any | null;
    price?: number | null;
    compareAtPrice?: number | null;
    sku?: string | null;
    weight?: number | null;
    weightUnit?: WeightUnit | null;
    barcode?: string | null;
    productMedia: Array<{ orderIndex: number; media: { cdnUrl: string } }>;
  }>;
};

export type CorePartialProduct = {
  id: string;
  createdAt: any;
  updatedAt: any;
  title: string;
  type: ProductType;
  productType?: string | null;
  shopId: string;
  description?: string | null;
  tags: Array<string>;
  productMedia: Array<{ orderIndex: number; media: { cdnUrl: string } }>;
};

export type CoreProductVariant = {
  id: string;
  createdAt: any;
  updatedAt: any;
  selectedVariantOptions?: any | null;
  price?: number | null;
  compareAtPrice?: number | null;
  sku?: string | null;
  weight?: number | null;
  weightUnit?: WeightUnit | null;
  barcode?: string | null;
  productMedia: Array<{ orderIndex: number; media: { cdnUrl: string } }>;
};

export type CoreRefund = {
  id: string;
  currency: Currency;
  price: number;
  type: RefundType;
  refundedLineItems: Array<{ id: string }>;
};

export type CoreReturnInsuranceLineItem = {
  id: string;
  currency: Currency;
  price: number;
  provider: ReturnInsuranceProvider;
  providerId: string;
};

export type CoreShippingLineItem = {
  id: string;
  currency: Currency;
  price: number;
  quantity: number;
};

export type CoreShopIntegration = {
  id: string;
  tier: string;
  title: string;
  subtitle: string;
  description: string;
  detailedDescription?: string | null;
  integrationType: string;
  integrationTarget: {
    title: string;
    description: string;
    applicationUrl?: string | null;
    treetSupportArticleUrl?: string | null;
    iconUrl?: string | null;
  };
  integration?: { integrationId: string; installed: boolean } | null;
  configuration?: { updatedAt: any; configuration: any; isActive: boolean } | null;
};

export type CoreTaxLineItem = {
  id: string;
  taxId: string;
  taxCode: string;
  currency: Currency;
  value: number;
  rate: number;
  metadata: any;
};

export type AddShipFromAddressToBundleVariables = Exact<{
  input: AddShipFromAddressInput;
}>;

export type AddShipFromAddressToBundleResponse = {
  addShipFromAddressToBundle: { bundle: { id: string } };
};

export type AllBrandDisbursementsVariables = Exact<{
  shopId: Scalars['String'];
}>;

export type AllBrandDisbursementsResponse = {
  brandDisbursements: Array<{
    id: string;
    startDate: any;
    endDate: any;
    earningsTotal: number;
    currency: Currency;
    status: DisbursementStatus;
  }>;
};

export type AllBrandReportsVariables = Exact<{
  shopId: Scalars['String'];
  cursor?: InputMaybe<Scalars['String']>;
}>;

export type AllBrandReportsResponse = {
  brandReports: Array<{ id: string; createdAt: any; startDate: any; endDate: any }>;
};

export type AllBundlesVariables = Exact<{
  userId: Scalars['String'];
  status?: InputMaybe<BundleStatus>;
  shopName?: InputMaybe<Scalars['String']>;
  sharetribeListingIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  searchQuery?: InputMaybe<Scalars['String']>;
}>;

export type AllBundlesResponse = {
  bundles: Array<{
    id: string;
    createdAt: any;
    expireAt?: any | null;
    sharetribeTransactionIds: Array<string>;
    status: BundleStatus;
    isMarkedFulfilled?: boolean | null;
    type?: BundleType | null;
    isBrandDirect: boolean;
    isReturnable?: boolean | null;
    payoutOption?: PayoutType | null;
    shopifyOrderId?: string | null;
    refunds: Array<{
      id: string;
      currency: Currency;
      price: number;
      type: RefundType;
      refundedLineItems: Array<{ id: string }>;
    }>;
    lineItems: Array<{
      id: string;
      name: string;
      code: LineItemCode;
      includeFor: Array<Participant>;
      listingLineItem?: {
        id: string;
        currency: Currency;
        price: number;
        quantity: number;
        sharetribeListingId: string;
      } | null;
      shippingLineItem?: { id: string; currency: Currency; price: number; quantity: number } | null;
      discountLineItem?: {
        id: string;
        title: string;
        currency: Currency;
        value: number;
        valueType: DiscountValueType;
        target: DiscountTarget;
        metadata: any;
      } | null;
      returnInsuranceLineItem?: {
        id: string;
        currency: Currency;
        price: number;
        provider: ReturnInsuranceProvider;
        providerId: string;
      } | null;
      taxLineItem?: {
        id: string;
        taxId: string;
        taxCode: string;
        currency: Currency;
        value: number;
        rate: number;
        metadata: any;
      } | null;
    }>;
    fulfillment?: {
      id: string;
      trackingURL: string;
      trackingNumber: string;
      labelURL?: string | null;
      weightUnit: WeightUnit;
      weight: number;
      shippingLabelProvider?: ShippingLabelProvider | null;
      deliveredAt?: any | null;
    } | null;
    returnFulfillment?: {
      id: string;
      trackingURL: string;
      trackingNumber: string;
      labelURL?: string | null;
      weightUnit: WeightUnit;
      weight: number;
      shippingLabelProvider?: ShippingLabelProvider | null;
      deliveredAt?: any | null;
    } | null;
    bundleItems: Array<{
      id: string;
      status?: ItemStatus | null;
      historicalStatuses: Array<BundleItemHistoricalStatus>;
      dispute?: { id: string; reason: DisputeReason; note?: string | null } | null;
      listing: { id: string; sharetribeListingId: string };
    }>;
    order: {
      id: string;
      sharetribeBuyerId: string;
      buyer?: { id: string; displayName: string } | null;
    };
  }>;
};

export type AllOrdersVariables = Exact<{
  userId: Scalars['String'];
  shopName?: InputMaybe<Scalars['String']>;
  bundleStatus?: InputMaybe<BundleStatus>;
  searchQuery?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;

export type AllOrdersResponse = {
  orders: Array<{
    id: string;
    createdAt: any;
    shippingAddress: {
      id: string;
      addressLine1: string;
      addressLine2?: string | null;
      city: string;
      state: string;
      country: string;
      zip: string;
      fullName: string;
      phone?: string | null;
    };
    billingAddress?: {
      id: string;
      addressLine1: string;
      addressLine2?: string | null;
      city: string;
      state: string;
      country: string;
      zip: string;
      fullName: string;
      phone?: string | null;
    } | null;
    bundles: Array<{
      id: string;
      createdAt: any;
      expireAt?: any | null;
      sharetribeTransactionIds: Array<string>;
      status: BundleStatus;
      isMarkedFulfilled?: boolean | null;
      type?: BundleType | null;
      isBrandDirect: boolean;
      isReturnable?: boolean | null;
      payoutOption?: PayoutType | null;
      shopifyOrderId?: string | null;
      refunds: Array<{
        id: string;
        currency: Currency;
        price: number;
        type: RefundType;
        refundedLineItems: Array<{ id: string }>;
      }>;
      lineItems: Array<{
        id: string;
        name: string;
        code: LineItemCode;
        includeFor: Array<Participant>;
        listingLineItem?: {
          id: string;
          currency: Currency;
          price: number;
          quantity: number;
          sharetribeListingId: string;
        } | null;
        shippingLineItem?: {
          id: string;
          currency: Currency;
          price: number;
          quantity: number;
        } | null;
        discountLineItem?: {
          id: string;
          title: string;
          currency: Currency;
          value: number;
          valueType: DiscountValueType;
          target: DiscountTarget;
          metadata: any;
        } | null;
        returnInsuranceLineItem?: {
          id: string;
          currency: Currency;
          price: number;
          provider: ReturnInsuranceProvider;
          providerId: string;
        } | null;
        taxLineItem?: {
          id: string;
          taxId: string;
          taxCode: string;
          currency: Currency;
          value: number;
          rate: number;
          metadata: any;
        } | null;
      }>;
      fulfillment?: {
        id: string;
        trackingURL: string;
        trackingNumber: string;
        labelURL?: string | null;
        weightUnit: WeightUnit;
        weight: number;
        shippingLabelProvider?: ShippingLabelProvider | null;
        deliveredAt?: any | null;
      } | null;
      returnFulfillment?: {
        id: string;
        trackingURL: string;
        trackingNumber: string;
        labelURL?: string | null;
        weightUnit: WeightUnit;
        weight: number;
        shippingLabelProvider?: ShippingLabelProvider | null;
        deliveredAt?: any | null;
      } | null;
      bundleItems: Array<{
        id: string;
        status?: ItemStatus | null;
        historicalStatuses: Array<BundleItemHistoricalStatus>;
        dispute?: { id: string; reason: DisputeReason; note?: string | null } | null;
        listing: { id: string; sharetribeListingId: string };
      }>;
      order: {
        id: string;
        sharetribeBuyerId: string;
        buyer?: { id: string; displayName: string } | null;
      };
    }>;
    lineItems: Array<{
      id: string;
      name: string;
      code: LineItemCode;
      includeFor: Array<Participant>;
      listingLineItem?: {
        id: string;
        currency: Currency;
        price: number;
        quantity: number;
        sharetribeListingId: string;
      } | null;
      shippingLineItem?: { id: string; currency: Currency; price: number; quantity: number } | null;
      discountLineItem?: {
        id: string;
        title: string;
        currency: Currency;
        value: number;
        valueType: DiscountValueType;
        target: DiscountTarget;
        metadata: any;
      } | null;
      returnInsuranceLineItem?: {
        id: string;
        currency: Currency;
        price: number;
        provider: ReturnInsuranceProvider;
        providerId: string;
      } | null;
      taxLineItem?: {
        id: string;
        taxId: string;
        taxCode: string;
        currency: Currency;
        value: number;
        rate: number;
        metadata: any;
      } | null;
    }>;
  }>;
};

export type AllShipmentCarriersVariables = Exact<{ [key: string]: never }>;

export type AllShipmentCarriersResponse = {
  couriers: Array<{
    slug: string;
    name: string;
    otherName?: string | null;
    webUrl: string;
    serviceFromCountryRegions: Array<string | null>;
  }>;
};

export type BundleByIdVariables = Exact<{
  bundleId: Scalars['String'];
}>;

export type BundleByIdResponse = {
  bundle?: {
    id: string;
    createdAt: any;
    expireAt?: any | null;
    sharetribeTransactionIds: Array<string>;
    status: BundleStatus;
    isMarkedFulfilled?: boolean | null;
    type?: BundleType | null;
    isBrandDirect: boolean;
    isReturnable?: boolean | null;
    payoutOption?: PayoutType | null;
    shopifyOrderId?: string | null;
    refunds: Array<{
      id: string;
      currency: Currency;
      price: number;
      type: RefundType;
      refundedLineItems: Array<{ id: string }>;
    }>;
    lineItems: Array<{
      id: string;
      name: string;
      code: LineItemCode;
      includeFor: Array<Participant>;
      listingLineItem?: {
        id: string;
        currency: Currency;
        price: number;
        quantity: number;
        sharetribeListingId: string;
      } | null;
      shippingLineItem?: { id: string; currency: Currency; price: number; quantity: number } | null;
      discountLineItem?: {
        id: string;
        title: string;
        currency: Currency;
        value: number;
        valueType: DiscountValueType;
        target: DiscountTarget;
        metadata: any;
      } | null;
      returnInsuranceLineItem?: {
        id: string;
        currency: Currency;
        price: number;
        provider: ReturnInsuranceProvider;
        providerId: string;
      } | null;
      taxLineItem?: {
        id: string;
        taxId: string;
        taxCode: string;
        currency: Currency;
        value: number;
        rate: number;
        metadata: any;
      } | null;
    }>;
    fulfillment?: {
      id: string;
      trackingURL: string;
      trackingNumber: string;
      labelURL?: string | null;
      weightUnit: WeightUnit;
      weight: number;
      shippingLabelProvider?: ShippingLabelProvider | null;
      deliveredAt?: any | null;
    } | null;
    returnFulfillment?: {
      id: string;
      trackingURL: string;
      trackingNumber: string;
      labelURL?: string | null;
      weightUnit: WeightUnit;
      weight: number;
      shippingLabelProvider?: ShippingLabelProvider | null;
      deliveredAt?: any | null;
    } | null;
    bundleItems: Array<{
      id: string;
      status?: ItemStatus | null;
      historicalStatuses: Array<BundleItemHistoricalStatus>;
      dispute?: { id: string; reason: DisputeReason; note?: string | null } | null;
      listing: { id: string; sharetribeListingId: string };
    }>;
    order: {
      id: string;
      sharetribeBuyerId: string;
      buyer?: { id: string; displayName: string } | null;
    };
  } | null;
};

export type BundleByIdWithOrderShippingAddressVariables = Exact<{
  bundleId: Scalars['String'];
  isReturn: Scalars['Boolean'];
}>;

export type BundleByIdWithOrderShippingAddressResponse = {
  bundle?: {
    id: string;
    createdAt: any;
    expireAt?: any | null;
    sharetribeTransactionIds: Array<string>;
    status: BundleStatus;
    isMarkedFulfilled?: boolean | null;
    type?: BundleType | null;
    isBrandDirect: boolean;
    isReturnable?: boolean | null;
    payoutOption?: PayoutType | null;
    shopifyOrderId?: string | null;
    shipFromAddress?: {
      id: string;
      addressLine1: string;
      addressLine2?: string | null;
      city: string;
      state: string;
      country: string;
      zip: string;
      fullName: string;
      phone?: string | null;
    } | null;
    order: {
      id: string;
      sharetribeBuyerId: string;
      shippingAddress?: {
        id: string;
        addressLine1: string;
        addressLine2?: string | null;
        city: string;
        state: string;
        country: string;
        zip: string;
        fullName: string;
        phone?: string | null;
      };
      buyer?: { id: string; displayName: string } | null;
    };
    refunds: Array<{
      id: string;
      currency: Currency;
      price: number;
      type: RefundType;
      refundedLineItems: Array<{ id: string }>;
    }>;
    lineItems: Array<{
      id: string;
      name: string;
      code: LineItemCode;
      includeFor: Array<Participant>;
      listingLineItem?: {
        id: string;
        currency: Currency;
        price: number;
        quantity: number;
        sharetribeListingId: string;
      } | null;
      shippingLineItem?: { id: string; currency: Currency; price: number; quantity: number } | null;
      discountLineItem?: {
        id: string;
        title: string;
        currency: Currency;
        value: number;
        valueType: DiscountValueType;
        target: DiscountTarget;
        metadata: any;
      } | null;
      returnInsuranceLineItem?: {
        id: string;
        currency: Currency;
        price: number;
        provider: ReturnInsuranceProvider;
        providerId: string;
      } | null;
      taxLineItem?: {
        id: string;
        taxId: string;
        taxCode: string;
        currency: Currency;
        value: number;
        rate: number;
        metadata: any;
      } | null;
    }>;
    fulfillment?: {
      id: string;
      trackingURL: string;
      trackingNumber: string;
      labelURL?: string | null;
      weightUnit: WeightUnit;
      weight: number;
      shippingLabelProvider?: ShippingLabelProvider | null;
      deliveredAt?: any | null;
    } | null;
    returnFulfillment?: {
      id: string;
      trackingURL: string;
      trackingNumber: string;
      labelURL?: string | null;
      weightUnit: WeightUnit;
      weight: number;
      shippingLabelProvider?: ShippingLabelProvider | null;
      deliveredAt?: any | null;
    } | null;
    bundleItems: Array<{
      id: string;
      status?: ItemStatus | null;
      historicalStatuses: Array<BundleItemHistoricalStatus>;
      dispute?: { id: string; reason: DisputeReason; note?: string | null } | null;
      listing: { id: string; sharetribeListingId: string };
    }>;
  } | null;
};

export type CartItemsVariables = Exact<{ [key: string]: never }>;

export type CartItemsResponse = {
  cartItems: Array<{ id: string; listing: { id: string; sharetribeListingId: string } }>;
};

export type CreateCancellationVariables = Exact<{
  input: CreateCancellationInput;
}>;

export type CreateCancellationResponse = { createCancellation: { cancellation: { id: string } } };

export type CreateCartItemVariables = Exact<{
  input: CreateCartItemInput;
}>;

export type CreateCartItemResponse = {
  createCartItem: Array<{ id: string; listing: { id: string; sharetribeListingId: string } }>;
};

export type UpsertDisputeVariables = Exact<{
  input: UpsertDisputeInput;
}>;

export type UpsertDisputeResponse = { upsertDispute: { dispute: { id: string } } };

export type CreateFavoritedItemVariables = Exact<{
  input: CreateFavoritedItemInput;
}>;

export type CreateFavoritedItemResponse = {
  createFavoritedItem: { favoritedItem: { userId: string; listingId: string } };
};

export type CreateFulfillmentFromTrackingInfoVariables = Exact<{
  input: CreateFulfillmentFromTrackingInfoInput;
}>;

export type CreateFulfillmentFromTrackingInfoResponse = {
  createFulfillmentFromTrackingInfo: {
    id: string;
    returnBundle?: { id: string } | null;
    bundle?: { id: string } | null;
  };
};

export type UpsertListingVariables = Exact<{
  input: UpsertListingInput;
}>;

export type UpsertListingResponse = { upsertListing: { listing: { id: string } } };

export type CreateListingFeedbackVariables = Exact<{
  input: CreateListingFeedbackInput;
}>;

export type CreateListingFeedbackResponse = {
  createListingFeedback: { listingFeedback: { id: string } };
};

export type CreateUserVariables = Exact<{
  input: CreateUserInput;
}>;

export type CreateUserResponse = { createUser: { user: { id: string } } };

export type CreditCodeByBundleIdVariables = Exact<{
  bundleId: Scalars['String'];
}>;

export type CreditCodeByBundleIdResponse = {
  bundle?: {
    id: string;
    creditCode?: {
      id: string;
      maskedCode?: string | null;
      amount: number;
      type: CreditCodeType;
      currency: Currency;
      expireAt?: any | null;
    } | null;
  } | null;
};

export type CurrentUserHasSalesVariables = Exact<{ [key: string]: never }>;

export type CurrentUserHasSalesResponse = { currentUser?: { hasSales?: boolean | null } | null };

export type DeleteDraftListingVariables = Exact<{
  input: DraftListingInput;
}>;

export type DeleteDraftListingResponse = { deleteDraftListing: { id: string } };

export type DisbursementByIdVariables = Exact<{
  disbursementId: Scalars['String'];
}>;

export type DisbursementByIdResponse = {
  disbursement?: {
    id: string;
    startDate: any;
    endDate: any;
    type: DisbursementType;
    status: DisbursementStatus;
    currency: Currency;
    discountsTotal?: number | null;
    returnInsuranceTotal?: number | null;
    shippingTotal?: number | null;
    taxTotal?: number | null;
    customerPaidTotal: number;
    peerCashSalesGMVTotal?: number | null;
    peerCreditSalesGMVTotal?: number | null;
    brandDirectSalesGMVTotal?: number | null;
    relistedTradeInSalesGMVTotal?: number | null;
    grossMerchandiseValueTotal: number;
    peerSellerPayoutTotal?: number | null;
    treetTakeTotal: number;
    ccProcessingTotal: number;
    brandCoveredDiscountsTotal?: number | null;
    salesCostTotal: number;
    reimbursedShippingCostTotal?: number | null;
    additionalLineItems?: any | null;
    reimbursementsTotal: number;
    returnShippingCostTotal?: number | null;
    brandCoveredShippingCostTotal?: number | null;
    additionalCostsTotal: number;
    brandDirectSalesPayoutTotal: number;
    relistedTradeInSalesPayoutTotal: number;
    previouslyDepositedTotal?: number | null;
    grossMarginTotal: number;
    earningsTotal: number;
    finalDepositTotal?: number | null;
  } | null;
};

export type DraftListingVariables = Exact<{
  input: DraftListingInput;
}>;

export type DraftListingResponse = {
  draftListing: {
    id: string;
    createdAt: any;
    updatedAt: any;
    state: DraftListingState;
    sharetribeListingId?: string | null;
    title?: string | null;
    price?: number | null;
    currency?: Currency | null;
    findItemMethod?: FindItemMethod | null;
    itemBrand?: string | null;
    itemType?: ListingItemType | null;
    categories: Array<string>;
    privateSellerNotes?: string | null;
    condition?: ListingCondition | null;
    notes?: string | null;
    originalPrice?: number | null;
    quirks: Array<string>;
    selectedVariantOptions?: any | null;
    sellerPhotos: Array<any>;
    stockPhotoUrls: Array<string>;
    priceDropConfigJson?: any | null;
    shopId: string;
    sellerId?: string | null;
    publishedListingId?: string | null;
    productId?: string | null;
    listingFlowMetadata?: any | null;
    sourceListingId?: string | null;
    product?: {
      id: string;
      createdAt: any;
      updatedAt: any;
      title: string;
      type: ProductType;
      productType?: string | null;
      shopId: string;
      description?: string | null;
      tags: Array<string>;
      productMedia: Array<{ orderIndex: number; media: { cdnUrl: string } }>;
      productVariants: Array<{
        id: string;
        createdAt: any;
        updatedAt: any;
        selectedVariantOptions?: any | null;
        price?: number | null;
        compareAtPrice?: number | null;
        sku?: string | null;
        weight?: number | null;
        weightUnit?: WeightUnit | null;
        barcode?: string | null;
        productMedia: Array<{ orderIndex: number; media: { cdnUrl: string } }>;
      }>;
    } | null;
    productVariant?: {
      id: string;
      createdAt: any;
      updatedAt: any;
      selectedVariantOptions?: any | null;
      price?: number | null;
      compareAtPrice?: number | null;
      sku?: string | null;
      weight?: number | null;
      weightUnit?: WeightUnit | null;
      barcode?: string | null;
      productMedia: Array<{ orderIndex: number; media: { cdnUrl: string } }>;
    } | null;
    publishedListing?: { title: string; sharetribeListingId: string } | null;
  };
};

export type DraftListingsVariables = Exact<{
  input?: InputMaybe<DraftListingFilterInput>;
}>;

export type DraftListingsResponse = {
  draftListings: Array<{
    id: string;
    createdAt: any;
    updatedAt: any;
    state: DraftListingState;
    sharetribeListingId?: string | null;
    title?: string | null;
    price?: number | null;
    currency?: Currency | null;
    findItemMethod?: FindItemMethod | null;
    itemBrand?: string | null;
    itemType?: ListingItemType | null;
    categories: Array<string>;
    privateSellerNotes?: string | null;
    condition?: ListingCondition | null;
    notes?: string | null;
    originalPrice?: number | null;
    quirks: Array<string>;
    selectedVariantOptions?: any | null;
    sellerPhotos: Array<any>;
    stockPhotoUrls: Array<string>;
    priceDropConfigJson?: any | null;
    shopId: string;
    sellerId?: string | null;
    publishedListingId?: string | null;
    productId?: string | null;
    listingFlowMetadata?: any | null;
    sourceListingId?: string | null;
    product?: {
      id: string;
      createdAt: any;
      updatedAt: any;
      title: string;
      type: ProductType;
      productType?: string | null;
      shopId: string;
      description?: string | null;
      tags: Array<string>;
      productMedia: Array<{ orderIndex: number; media: { cdnUrl: string } }>;
      productVariants: Array<{
        id: string;
        createdAt: any;
        updatedAt: any;
        selectedVariantOptions?: any | null;
        price?: number | null;
        compareAtPrice?: number | null;
        sku?: string | null;
        weight?: number | null;
        weightUnit?: WeightUnit | null;
        barcode?: string | null;
        productMedia: Array<{ orderIndex: number; media: { cdnUrl: string } }>;
      }>;
    } | null;
    productVariant?: {
      id: string;
      createdAt: any;
      updatedAt: any;
      selectedVariantOptions?: any | null;
      price?: number | null;
      compareAtPrice?: number | null;
      sku?: string | null;
      weight?: number | null;
      weightUnit?: WeightUnit | null;
      barcode?: string | null;
      productMedia: Array<{ orderIndex: number; media: { cdnUrl: string } }>;
    } | null;
    publishedListing?: { title: string; sharetribeListingId: string } | null;
  }>;
};

export type FavoritedItemsVariables = Exact<{
  treetId: Scalars['String'];
}>;

export type FavoritedItemsResponse = {
  favoritedItems: Array<{ id: string; listing: { id: string; sharetribeListingId: string } }>;
};

export type GetBundleShipFromAddressVariables = Exact<{
  bundleId: Scalars['String'];
}>;

export type GetBundleShipFromAddressResponse = {
  bundle?: {
    shipFromAddress?: {
      id: string;
      addressLine1: string;
      addressLine2?: string | null;
      city: string;
      country: string;
      fullName: string;
      phone?: string | null;
      zip: string;
      state: string;
    } | null;
  } | null;
};

export type ListingsVariables = Exact<{
  input?: InputMaybe<ListingsInput>;
}>;

export type ListingsResponse = {
  listings: Array<{
    id: string;
    createdAt: any;
    updatedAt: any;
    sharetribeListingId: string;
    title: string;
    price?: number | null;
    externalSku?: string | null;
    availableInventory?: number | null;
    state?: ListingState | null;
    currency?: string | null;
    shipFromCountry?: CountryCode | null;
    findItemMethod?: FindItemMethod | null;
    itemBrand?: string | null;
    sourceListingId?: string | null;
    isBrandDirect?: boolean | null;
    itemType?: ListingItemType | null;
    sharetribePublicData?: any | null;
    deletedAt?: any | null;
    categories?: Array<string | null> | null;
    condition?: ListingCondition | null;
    notes?: string | null;
    originalPrice?: number | null;
    productHtml?: string | null;
    quirks?: Array<string | null> | null;
    selectedVariantOptions?: any | null;
    tags?: Array<string | null> | null;
    promosActive?: Array<string | null> | null;
    syncShopifyInventory?: boolean | null;
    approvedAt?: any | null;
    lastSoldAt?: any | null;
    isReturnable?: boolean | null;
    weight?: number | null;
    weightUnit?: WeightUnit | null;
    author?: any | null;
    listingMedia?: any | null;
    product?: {
      id: string;
      createdAt: any;
      updatedAt: any;
      title: string;
      type: ProductType;
      productType?: string | null;
      shopId: string;
      description?: string | null;
      tags: Array<string>;
      productMedia: Array<{ orderIndex: number; media: { cdnUrl: string } }>;
      productVariants: Array<{
        id: string;
        createdAt: any;
        updatedAt: any;
        selectedVariantOptions?: any | null;
        price?: number | null;
        compareAtPrice?: number | null;
        sku?: string | null;
        weight?: number | null;
        weightUnit?: WeightUnit | null;
        barcode?: string | null;
        productMedia: Array<{ orderIndex: number; media: { cdnUrl: string } }>;
      }>;
    } | null;
    productVariant?: {
      id: string;
      createdAt: any;
      updatedAt: any;
      selectedVariantOptions?: any | null;
      price?: number | null;
      compareAtPrice?: number | null;
      sku?: string | null;
      weight?: number | null;
      weightUnit?: WeightUnit | null;
      barcode?: string | null;
      productMedia: Array<{ orderIndex: number; media: { cdnUrl: string } }>;
    } | null;
  }>;
};

export type ListingsForManagementVariables = Exact<{
  input?: InputMaybe<ListingsInput>;
}>;

export type ListingsForManagementResponse = {
  listings: Array<{
    id: string;
    sharetribeListingId: string;
    canRelist: boolean;
    lastPurchaseBundleId?: string | null;
    wasCanceled: boolean;
  }>;
};

export type ListingsFullyPopulatedVariables = Exact<{
  input?: InputMaybe<ListingsInput>;
}>;

export type ListingsFullyPopulatedResponse = {
  listings: Array<{
    creditBoostPromoId?: string | null;
    internalNotes?: string | null;
    payoutInfo?: any | null;
    id: string;
    createdAt: any;
    updatedAt: any;
    sharetribeListingId: string;
    title: string;
    price?: number | null;
    externalSku?: string | null;
    availableInventory?: number | null;
    state?: ListingState | null;
    currency?: string | null;
    shipFromCountry?: CountryCode | null;
    findItemMethod?: FindItemMethod | null;
    itemBrand?: string | null;
    sourceListingId?: string | null;
    isBrandDirect?: boolean | null;
    itemType?: ListingItemType | null;
    sharetribePublicData?: any | null;
    deletedAt?: any | null;
    categories?: Array<string | null> | null;
    condition?: ListingCondition | null;
    notes?: string | null;
    originalPrice?: number | null;
    productHtml?: string | null;
    quirks?: Array<string | null> | null;
    selectedVariantOptions?: any | null;
    tags?: Array<string | null> | null;
    promosActive?: Array<string | null> | null;
    syncShopifyInventory?: boolean | null;
    approvedAt?: any | null;
    lastSoldAt?: any | null;
    isReturnable?: boolean | null;
    weight?: number | null;
    weightUnit?: WeightUnit | null;
    author?: any | null;
    listingMedia?: any | null;
    product?: {
      id: string;
      createdAt: any;
      updatedAt: any;
      title: string;
      type: ProductType;
      productType?: string | null;
      shopId: string;
      description?: string | null;
      tags: Array<string>;
      productMedia: Array<{ orderIndex: number; media: { cdnUrl: string } }>;
      productVariants: Array<{
        id: string;
        createdAt: any;
        updatedAt: any;
        selectedVariantOptions?: any | null;
        price?: number | null;
        compareAtPrice?: number | null;
        sku?: string | null;
        weight?: number | null;
        weightUnit?: WeightUnit | null;
        barcode?: string | null;
        productMedia: Array<{ orderIndex: number; media: { cdnUrl: string } }>;
      }>;
    } | null;
    productVariant?: {
      id: string;
      createdAt: any;
      updatedAt: any;
      selectedVariantOptions?: any | null;
      price?: number | null;
      compareAtPrice?: number | null;
      sku?: string | null;
      weight?: number | null;
      weightUnit?: WeightUnit | null;
      barcode?: string | null;
      productMedia: Array<{ orderIndex: number; media: { cdnUrl: string } }>;
    } | null;
  }>;
};

export type LoyaltyProgramByTreetIdVariables = Exact<{
  treetId: Scalars['String'];
}>;

export type LoyaltyProgramByTreetIdResponse = {
  shop?: {
    loyaltyProgram?: {
      pointsPerMoneyUnit: number;
      pointsName: string;
      programName: string;
      programUrl: string;
    } | null;
  } | null;
};

export type OrderByIdVariables = Exact<{
  orderId: Scalars['String'];
}>;

export type OrderByIdResponse = {
  order?: {
    sharetribeBuyerId: string;
    shippingAddress: {
      id: string;
      fullName: string;
      addressLine1: string;
      addressLine2?: string | null;
      city: string;
      country: string;
      state: string;
      zip: string;
    };
    bundles: Array<{
      id: string;
      sharetribeTransactionIds: Array<string>;
      status: BundleStatus;
      fulfillment?: { id: string } | null;
      lineItems: Array<{
        id: string;
        name: string;
        code: LineItemCode;
        includeFor: Array<Participant>;
        listingLineItem?: {
          id: string;
          currency: Currency;
          price: number;
          quantity: number;
          sharetribeListingId: string;
        } | null;
        shippingLineItem?: {
          id: string;
          currency: Currency;
          price: number;
          quantity: number;
        } | null;
        discountLineItem?: {
          id: string;
          title: string;
          currency: Currency;
          value: number;
          valueType: DiscountValueType;
          target: DiscountTarget;
          metadata: any;
        } | null;
        returnInsuranceLineItem?: {
          id: string;
          currency: Currency;
          price: number;
          provider: ReturnInsuranceProvider;
          providerId: string;
        } | null;
        taxLineItem?: {
          id: string;
          taxId: string;
          taxCode: string;
          currency: Currency;
          value: number;
          rate: number;
          metadata: any;
        } | null;
      }>;
      bundleItems: Array<{ id: string; listing: { id: string; sharetribeListingId: string } }>;
    }>;
  } | null;
};

export type ProductsByShopIdVariables = Exact<{
  shopId: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
  productType?: InputMaybe<Scalars['String']>;
}>;

export type ProductsByShopIdResponse = {
  products: {
    pageInfo: { hasNext: boolean; endCursor?: string | null; take: number };
    products: Array<{
      id: string;
      createdAt: any;
      updatedAt: any;
      title: string;
      type: ProductType;
      productType?: string | null;
      shopId: string;
      description?: string | null;
      tags: Array<string>;
      productMedia: Array<{ orderIndex: number; media: { cdnUrl: string } }>;
    }>;
  };
};

export type GetOrderProductsVariables = Exact<{
  treetId: Scalars['String'];
  countryCode: Scalars['String'];
  cursor?: InputMaybe<Scalars['String']>;
}>;

export type GetOrderProductsResponse = {
  getOrderProducts: {
    pageInfo: { endCursor?: string | null; hasNext: boolean };
    orderProducts: Array<{
      orderNumber: string;
      orderDate: string;
      products: Array<{
        id: string;
        title: string;
        description?: string | null;
        tags?: Array<string | null> | null;
        productType?: string | null;
        productMedia?: Array<{
          id: string;
          orderIndex: number;
          media: { id: string; cdnUrl: string };
        } | null> | null;
        productVariant?: {
          id: string;
          price?: number | null;
          compareAtPrice?: number | null;
          currency?: Currency | null;
          selectedVariantOptions?: any | null;
          sku?: string | null;
          weight?: number | null;
          weightUnit?: WeightUnit | null;
          barcode?: string | null;
          productMedia?: Array<{
            id: string;
            orderIndex: number;
            media: { id: string; cdnUrl: string };
          } | null> | null;
        } | null;
      }>;
    }>;
  };
};

export type PublishDraftListingVariables = Exact<{
  input: DraftListingInput;
}>;

export type PublishDraftListingResponse = { publishDraftListing: { id: string } };

export type RemoveCartItemVariables = Exact<{
  input: RemoveCartItemsInput;
}>;

export type RemoveCartItemResponse = {
  removeCartItem: Array<{ id: string; listing: { id: string; sharetribeListingId: string } }>;
};

export type RemoveFavoritedItemVariables = Exact<{
  input: RemoveFavoritedItemInput;
}>;

export type RemoveFavoritedItemResponse = {
  removeFavoritedItem: { favoritedItem: { userId: string; listingId: string } };
};

export type SavedSearchByEmailVariables = Exact<{
  email: Scalars['String'];
  treetId: Scalars['String'];
  type: SavedSearchType;
}>;

export type SavedSearchByEmailResponse = {
  savedSearch?: { id: string; search: any; cadence: Cadence } | null;
};

export type ShopByHostnameVariables = Exact<{
  hostname: Scalars['String'];
}>;

export type ShopByHostnameResponse = {
  shopByHostname?: {
    id: string;
    treetId: string;
    canonicalRootUrl: string;
    defaultCurrency?: Currency | null;
    primaryLocale: Locale;
  } | null;
};

export type ShopByTreetIdVariables = Exact<{
  treetId: Scalars['String'];
}>;

export type ShopByTreetIdResponse = {
  shop?: {
    id: string;
    canonicalRootUrl: string;
    defaultCurrency?: Currency | null;
    primaryLocale: Locale;
  } | null;
};

export type UpdateAddressVariables = Exact<{
  input: UpdateAddressInput;
}>;

export type UpdateAddressResponse = {
  updateAddress: {
    address: {
      id: string;
      addressLine1: string;
      addressLine2?: string | null;
      city: string;
      state: string;
      country: string;
      zip: string;
      fullName: string;
      phone?: string | null;
    };
  };
};

export type UpdateBundleVariables = Exact<{
  input: UpdateBundleInput;
}>;

export type UpdateBundleResponse = {
  updateBundle: {
    bundle: {
      id: string;
      status: BundleStatus;
      isMarkedFulfilled?: boolean | null;
      canceledAt?: any | null;
      expireAt?: any | null;
      lineItems: Array<{
        id: string;
        name: string;
        code: LineItemCode;
        includeFor: Array<Participant>;
        listingLineItem?: {
          id: string;
          currency: Currency;
          price: number;
          quantity: number;
          sharetribeListingId: string;
        } | null;
        shippingLineItem?: {
          id: string;
          currency: Currency;
          price: number;
          quantity: number;
        } | null;
        discountLineItem?: {
          id: string;
          title: string;
          currency: Currency;
          value: number;
          valueType: DiscountValueType;
          target: DiscountTarget;
          metadata: any;
        } | null;
        returnInsuranceLineItem?: {
          id: string;
          currency: Currency;
          price: number;
          provider: ReturnInsuranceProvider;
          providerId: string;
        } | null;
        taxLineItem?: {
          id: string;
          taxId: string;
          taxCode: string;
          currency: Currency;
          value: number;
          rate: number;
          metadata: any;
        } | null;
      }>;
    };
  };
};

export type UpdateBundleItemVariables = Exact<{
  input: UpdateBundleItemInput;
}>;

export type UpdateBundleItemResponse = {
  updateBundleItem: { bundleItem: { id: string; status?: ItemStatus | null } };
};

export type UpdateUserVariables = Exact<{
  input: UpdateUserInput;
}>;

export type UpdateUserResponse = {
  updateUser: { user: { email: string; stripeAccountId?: string | null } };
};

export type UpsertDraftListingVariables = Exact<{
  input: UpsertDraftListingInput;
}>;

export type UpsertDraftListingResponse = {
  upsertDraftListing: {
    id: string;
    createdAt: any;
    updatedAt: any;
    state: DraftListingState;
    sharetribeListingId?: string | null;
    title?: string | null;
    price?: number | null;
    currency?: Currency | null;
    findItemMethod?: FindItemMethod | null;
    itemBrand?: string | null;
    itemType?: ListingItemType | null;
    categories: Array<string>;
    privateSellerNotes?: string | null;
    condition?: ListingCondition | null;
    notes?: string | null;
    originalPrice?: number | null;
    quirks: Array<string>;
    selectedVariantOptions?: any | null;
    sellerPhotos: Array<any>;
    stockPhotoUrls: Array<string>;
    priceDropConfigJson?: any | null;
    shopId: string;
    sellerId?: string | null;
    publishedListingId?: string | null;
    productId?: string | null;
    listingFlowMetadata?: any | null;
    sourceListingId?: string | null;
    product?: {
      id: string;
      createdAt: any;
      updatedAt: any;
      title: string;
      type: ProductType;
      productType?: string | null;
      shopId: string;
      description?: string | null;
      tags: Array<string>;
      productMedia: Array<{ orderIndex: number; media: { cdnUrl: string } }>;
      productVariants: Array<{
        id: string;
        createdAt: any;
        updatedAt: any;
        selectedVariantOptions?: any | null;
        price?: number | null;
        compareAtPrice?: number | null;
        sku?: string | null;
        weight?: number | null;
        weightUnit?: WeightUnit | null;
        barcode?: string | null;
        productMedia: Array<{ orderIndex: number; media: { cdnUrl: string } }>;
      }>;
    } | null;
    productVariant?: {
      id: string;
      createdAt: any;
      updatedAt: any;
      selectedVariantOptions?: any | null;
      price?: number | null;
      compareAtPrice?: number | null;
      sku?: string | null;
      weight?: number | null;
      weightUnit?: WeightUnit | null;
      barcode?: string | null;
      productMedia: Array<{ orderIndex: number; media: { cdnUrl: string } }>;
    } | null;
    publishedListing?: { title: string; sharetribeListingId: string } | null;
  };
};

export type UpsertGeneralSavedSearchVariables = Exact<{
  input: UpsertGeneralSavedSearchInput;
}>;

export type UpsertGeneralSavedSearchResponse = {
  upsertGeneralSavedSearch: {
    savedSearch: {
      id: string;
      email: string;
      search: any;
      cadence: Cadence;
      subscribeSource: EmailSubscribeSource;
      shop: { id: string };
    };
  };
};

export type UpsertIsoSavedSearchVariables = Exact<{
  input: UpsertIsoSavedSearchInput;
}>;

export type UpsertIsoSavedSearchResponse = {
  upsertISOSavedSearch: {
    savedSearch: {
      id: string;
      email: string;
      search: any;
      cadence: Cadence;
      subscribeSource: EmailSubscribeSource;
      shop: { id: string };
    };
    metadata?: { created?: boolean | null; updated?: boolean | null } | null;
  };
};

export type UpsertPhotosOnDraftVariables = Exact<{
  sellerPhotos: Array<Scalars['Json']> | Scalars['Json'];
  draftListingId: Scalars['ID'];
}>;

export type UpsertPhotosOnDraftResponse = {
  upsertPhotosOnDraft: { id: string; sellerPhotos: Array<any> };
};

export type UpsertPriceDropConfigVariables = Exact<{
  input: UpsertPriceDropConfigInput;
}>;

export type UpsertPriceDropConfigResponse = {
  upsertPriceDropConfig: {
    priceDropConfig: {
      id: string;
      isActive: boolean;
      minPrice: number;
      nextScheduledDrop?: any | null;
      percentageDrop: number;
      anchorPrice: number;
    };
  };
};

export type UpdateUserShipFromCountryVariables = Exact<{
  input: UpdateUserShipFromCountryInput;
}>;

export type UpdateUserShipFromCountryResponse = {
  updateUserShipFromCountry: { shipFromCountry?: CountryCode | null };
};

export type ShopIntegrationsByShopIdVariables = Exact<{
  shopId: Scalars['String'];
}>;

export type ShopIntegrationsByShopIdResponse = {
  shopIntegrations: Array<{
    id: string;
    tier: string;
    title: string;
    subtitle: string;
    description: string;
    detailedDescription?: string | null;
    integrationType: string;
    integrationTarget: { iconUrl?: string | null };
    tags?: Array<{ key: string; title: string }> | null;
    integration?: { installed: boolean } | null;
    configuration?: { isActive: boolean } | null;
  }>;
};

export type ShopIntegrationByShopIdAndIntegrationTypeVariables = Exact<{
  shopId: Scalars['String'];
  integrationType: ShopIntegrationType;
}>;

export type ShopIntegrationByShopIdAndIntegrationTypeResponse = {
  shopIntegration?: {
    id: string;
    tier: string;
    title: string;
    subtitle: string;
    description: string;
    detailedDescription?: string | null;
    integrationType: string;
    integrationTarget: {
      title: string;
      description: string;
      applicationUrl?: string | null;
      treetSupportArticleUrl?: string | null;
      iconUrl?: string | null;
    };
    integration?: { integrationId: string; installed: boolean } | null;
    configuration?: { updatedAt: any; configuration: any; isActive: boolean } | null;
  } | null;
};

export type ShopIntegrationInstalledStatusByShopIdAndIntegrationTypeVariables = Exact<{
  shopId: Scalars['String'];
  integrationType: ShopIntegrationType;
}>;

export type ShopIntegrationInstalledStatusByShopIdAndIntegrationTypeResponse = {
  shopIntegration?: { id: string; integration?: { installed: boolean } | null } | null;
};

export type ShopAlloyTokenByShopIdVariables = Exact<{
  shopId: Scalars['String'];
}>;

export type ShopAlloyTokenByShopIdResponse = { shopAlloyToken?: string | null };

export type UpsertShopIntegrationVariables = Exact<{
  input: ShopIntegrationSaveInput;
}>;

export type UpsertShopIntegrationResponse = {
  saveShopIntegrationConfig?: {
    validationErrors: Array<{ key: string; reason: string } | null>;
    configuration?: { id: string; isActive: boolean; configuration: any } | null;
  } | null;
};

export type BrandHealthActionsVariables = Exact<{ [key: string]: never }>;

export type BrandHealthActionsResponse = {
  brandHealthActions: Array<{
    key: string;
    includeForExperiences: Array<string>;
    excludeForExperiences?: Array<string | null> | null;
    title: string;
    categories: Array<string>;
    impact: string;
    time: string;
  }>;
};

export type BrandHealthActionByKeyVariables = Exact<{
  key: Scalars['String'];
}>;

export type BrandHealthActionByKeyResponse = {
  brandHealthAction?: {
    key: string;
    title: string;
    categories: Array<string>;
    impact: string;
    time: string;
    description?: string | null;
    whyExplainer?: string | null;
    implementationInstructions?: string | null;
    actionButtonText?: string | null;
    actionButtonLink?: string | null;
  } | null;
};

export type MostRecentBrandHealthLogByShopIdVariables = Exact<{
  shopId: Scalars['String'];
}>;

export type MostRecentBrandHealthLogByShopIdResponse = {
  brandHealthLog?: {
    id: string;
    createdAt: any;
    inventoryScore: number;
    promotionScore: number;
    overallScore: number;
    inventoryScoreGrade: BrandHealthGrade;
    promotionScoreGrade: BrandHealthGrade;
    overallScoreGrade: BrandHealthGrade;
    actionsTaken: any;
  } | null;
};

export type GetPriceDropConfigBySharetribeListingIdVariables = Exact<{
  sharetribeListingId?: InputMaybe<Scalars['ID']>;
}>;

export type GetPriceDropConfigBySharetribeListingIdResponse = {
  priceDropConfig?: {
    id: string;
    anchorPrice: number;
    minPrice: number;
    nextScheduledDrop?: any | null;
    isActive: boolean;
    percentageDrop: number;
    listingId: string;
  } | null;
};

export type IsoSavedSearchesByEmailVariables = Exact<{
  email: Scalars['String'];
  treetId: Scalars['String'];
}>;

export type IsoSavedSearchesByEmailResponse = {
  isoSavedSearches: Array<{ id: string; search: any }>;
};

export const CoreDisbursement = gql`
  fragment CoreDisbursement on Disbursement {
    id
    startDate
    endDate
    earningsTotal
    currency
    status
  }
`;
export const CoreProductVariant = gql`
  fragment CoreProductVariant on ProductVariant {
    id
    createdAt
    updatedAt
    selectedVariantOptions
    price
    compareAtPrice
    sku
    weight
    weightUnit
    barcode
    productMedia {
      orderIndex
      media {
        cdnUrl
      }
    }
  }
`;
export const CoreProduct = gql`
  fragment CoreProduct on Product {
    id
    createdAt
    updatedAt
    title
    type
    productType
    shopId
    description
    tags
    productMedia {
      orderIndex
      media {
        cdnUrl
      }
    }
    productVariants {
      ...CoreProductVariant
    }
  }
  ${CoreProductVariant}
`;
export const CoreDraftListing = gql`
  fragment CoreDraftListing on DraftListing {
    id
    createdAt
    updatedAt
    state
    sharetribeListingId
    title
    price
    currency
    findItemMethod
    itemBrand
    itemType
    categories
    privateSellerNotes
    condition
    notes
    originalPrice
    quirks
    selectedVariantOptions
    sellerPhotos
    stockPhotoUrls
    priceDropConfigJson
    shopId
    sellerId
    publishedListingId
    productId
    listingFlowMetadata
    product {
      ...CoreProduct
    }
    productVariant {
      ...CoreProductVariant
    }
    sourceListingId
    publishedListing {
      title
      sharetribeListingId
    }
  }
  ${CoreProduct}
  ${CoreProductVariant}
`;
export const CoreListing = gql`
  fragment CoreListing on Listing {
    id
    createdAt
    updatedAt
    sharetribeListingId
    title
    price
    externalSku
    availableInventory
    state
    currency
    shipFromCountry
    findItemMethod
    itemBrand
    sourceListingId
    isBrandDirect
    itemType
    sharetribePublicData
    deletedAt
    categories
    condition
    notes
    originalPrice
    productHtml
    quirks
    selectedVariantOptions
    tags
    promosActive
    syncShopifyInventory
    approvedAt
    lastSoldAt
    isReturnable
    weight
    weightUnit
    author
    listingMedia
    product {
      ...CoreProduct
    }
    productVariant {
      ...CoreProductVariant
    }
  }
  ${CoreProduct}
  ${CoreProductVariant}
`;
export const CoreAddress = gql`
  fragment CoreAddress on Address {
    id
    addressLine1
    addressLine2
    city
    state
    country
    zip
    fullName
    phone
  }
`;
export const CoreRefund = gql`
  fragment CoreRefund on Refund {
    id
    currency
    price
    type
    refundedLineItems {
      id
    }
  }
`;
export const CoreListingLineItem = gql`
  fragment CoreListingLineItem on ListingLineItem {
    id
    currency
    price
    quantity
    sharetribeListingId
  }
`;
export const CoreShippingLineItem = gql`
  fragment CoreShippingLineItem on ShippingLineItem {
    id
    currency
    price
    quantity
  }
`;
export const CoreDiscountLineItem = gql`
  fragment CoreDiscountLineItem on DiscountLineItem {
    id
    title
    currency
    value
    valueType
    target
    metadata
  }
`;
export const CoreReturnInsuranceLineItem = gql`
  fragment CoreReturnInsuranceLineItem on ReturnInsuranceLineItem {
    id
    currency
    price
    provider
    providerId
  }
`;
export const CoreTaxLineItem = gql`
  fragment CoreTaxLineItem on TaxLineItem {
    id
    taxId
    taxCode
    currency
    value
    rate
    metadata
  }
`;
export const CoreLineItem = gql`
  fragment CoreLineItem on LineItem {
    id
    name
    code
    includeFor
    listingLineItem {
      ...CoreListingLineItem
    }
    shippingLineItem {
      ...CoreShippingLineItem
    }
    discountLineItem {
      ...CoreDiscountLineItem
    }
    returnInsuranceLineItem {
      ...CoreReturnInsuranceLineItem
    }
    taxLineItem {
      ...CoreTaxLineItem
    }
  }
  ${CoreListingLineItem}
  ${CoreShippingLineItem}
  ${CoreDiscountLineItem}
  ${CoreReturnInsuranceLineItem}
  ${CoreTaxLineItem}
`;
export const CoreFulfillment = gql`
  fragment CoreFulfillment on Fulfillment {
    id
    trackingURL
    trackingNumber
    labelURL
    weightUnit
    weight
    shippingLabelProvider
    deliveredAt
  }
`;
export const CoreBundleItem = gql`
  fragment CoreBundleItem on BundleItem {
    id
    status
    dispute {
      id
      reason
      note
    }
    historicalStatuses
    listing {
      id
      sharetribeListingId
    }
  }
`;
export const CoreBundle = gql`
  fragment CoreBundle on Bundle {
    id
    createdAt
    expireAt
    sharetribeTransactionIds
    status
    isMarkedFulfilled
    type
    isBrandDirect
    isReturnable
    payoutOption
    shopifyOrderId
    refunds {
      ...CoreRefund
    }
    lineItems {
      ...CoreLineItem
    }
    fulfillment {
      ...CoreFulfillment
    }
    returnFulfillment {
      ...CoreFulfillment
    }
    bundleItems {
      ...CoreBundleItem
    }
    order {
      id
      sharetribeBuyerId
      buyer {
        id
        displayName
      }
    }
  }
  ${CoreRefund}
  ${CoreLineItem}
  ${CoreFulfillment}
  ${CoreBundleItem}
`;
export const CoreOrder = gql`
  fragment CoreOrder on Order {
    id
    createdAt
    shippingAddress {
      ...CoreAddress
    }
    billingAddress {
      ...CoreAddress
    }
    bundles {
      ...CoreBundle
    }
    lineItems {
      ...CoreLineItem
    }
  }
  ${CoreAddress}
  ${CoreBundle}
  ${CoreLineItem}
`;
export const CorePartialProduct = gql`
  fragment CorePartialProduct on Product {
    id
    createdAt
    updatedAt
    title
    type
    productType
    shopId
    description
    tags
    productMedia {
      orderIndex
      media {
        cdnUrl
      }
    }
  }
`;
export const CoreShopIntegration = gql`
  fragment CoreShopIntegration on ShopIntegration {
    id
    tier
    title
    subtitle
    description
    detailedDescription
    integrationTarget {
      title
      description
      applicationUrl
      treetSupportArticleUrl
      iconUrl
    }
    integrationType
    integration {
      integrationId
      installed
    }
    configuration {
      updatedAt
      configuration
      isActive
    }
  }
`;
export const AddShipFromAddressToBundleDocument = gql`
  mutation AddShipFromAddressToBundle($input: AddShipFromAddressInput!) {
    addShipFromAddressToBundle(input: $input) {
      bundle {
        id
      }
    }
  }
`;
export type AddShipFromAddressToBundleMutationFn = Apollo.MutationFunction<
  AddShipFromAddressToBundleResponse,
  AddShipFromAddressToBundleVariables
>;

/**
 * __useAddShipFromAddressToBundle__
 *
 * To run a mutation, you first call `useAddShipFromAddressToBundle` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddShipFromAddressToBundle` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addShipFromAddressToBundle, { data, loading, error }] = useAddShipFromAddressToBundle({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddShipFromAddressToBundle(
  baseOptions?: Apollo.MutationHookOptions<
    AddShipFromAddressToBundleResponse,
    AddShipFromAddressToBundleVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddShipFromAddressToBundleResponse,
    AddShipFromAddressToBundleVariables
  >(AddShipFromAddressToBundleDocument, options);
}
export type AddShipFromAddressToBundleHookResult = ReturnType<typeof useAddShipFromAddressToBundle>;
export type AddShipFromAddressToBundleMutationResult =
  Apollo.MutationResult<AddShipFromAddressToBundleResponse>;
export type AddShipFromAddressToBundleMutationOptions = Apollo.BaseMutationOptions<
  AddShipFromAddressToBundleResponse,
  AddShipFromAddressToBundleVariables
>;
export const AllBrandDisbursementsDocument = gql`
  query AllBrandDisbursements($shopId: String!) {
    brandDisbursements(shopId: $shopId) {
      ...CoreDisbursement
    }
  }
  ${CoreDisbursement}
`;

/**
 * __useAllBrandDisbursements__
 *
 * To run a query within a React component, call `useAllBrandDisbursements` and pass it any options that fit your needs.
 * When your component renders, `useAllBrandDisbursements` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllBrandDisbursements({
 *   variables: {
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useAllBrandDisbursements(
  baseOptions: Apollo.QueryHookOptions<
    AllBrandDisbursementsResponse,
    AllBrandDisbursementsVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AllBrandDisbursementsResponse, AllBrandDisbursementsVariables>(
    AllBrandDisbursementsDocument,
    options
  );
}
export function useAllBrandDisbursementsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AllBrandDisbursementsResponse,
    AllBrandDisbursementsVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AllBrandDisbursementsResponse, AllBrandDisbursementsVariables>(
    AllBrandDisbursementsDocument,
    options
  );
}
export type AllBrandDisbursementsHookResult = ReturnType<typeof useAllBrandDisbursements>;
export type AllBrandDisbursementsLazyQueryHookResult = ReturnType<
  typeof useAllBrandDisbursementsLazyQuery
>;
export type AllBrandDisbursementsQueryResult = Apollo.QueryResult<
  AllBrandDisbursementsResponse,
  AllBrandDisbursementsVariables
>;
export const AllBrandReportsDocument = gql`
  query AllBrandReports($shopId: String!, $cursor: String) {
    brandReports(shopId: $shopId, cursor: $cursor) {
      id
      createdAt
      startDate
      endDate
    }
  }
`;

/**
 * __useAllBrandReports__
 *
 * To run a query within a React component, call `useAllBrandReports` and pass it any options that fit your needs.
 * When your component renders, `useAllBrandReports` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllBrandReports({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useAllBrandReports(
  baseOptions: Apollo.QueryHookOptions<AllBrandReportsResponse, AllBrandReportsVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AllBrandReportsResponse, AllBrandReportsVariables>(
    AllBrandReportsDocument,
    options
  );
}
export function useAllBrandReportsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AllBrandReportsResponse, AllBrandReportsVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AllBrandReportsResponse, AllBrandReportsVariables>(
    AllBrandReportsDocument,
    options
  );
}
export type AllBrandReportsHookResult = ReturnType<typeof useAllBrandReports>;
export type AllBrandReportsLazyQueryHookResult = ReturnType<typeof useAllBrandReportsLazyQuery>;
export type AllBrandReportsQueryResult = Apollo.QueryResult<
  AllBrandReportsResponse,
  AllBrandReportsVariables
>;
export const AllBundlesDocument = gql`
  query AllBundles(
    $userId: String!
    $status: BundleStatus
    $shopName: String
    $sharetribeListingIds: [String!]
    $limit: Int
    $offset: Int
    $searchQuery: String
  ) {
    bundles(
      sharetribeSellerId: $userId
      status: $status
      shopName: $shopName
      sharetribeListingIds: $sharetribeListingIds
      limit: $limit
      offset: $offset
      searchQuery: $searchQuery
    ) {
      ...CoreBundle
    }
  }
  ${CoreBundle}
`;

/**
 * __useAllBundles__
 *
 * To run a query within a React component, call `useAllBundles` and pass it any options that fit your needs.
 * When your component renders, `useAllBundles` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllBundles({
 *   variables: {
 *      userId: // value for 'userId'
 *      status: // value for 'status'
 *      shopName: // value for 'shopName'
 *      sharetribeListingIds: // value for 'sharetribeListingIds'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useAllBundles(
  baseOptions: Apollo.QueryHookOptions<AllBundlesResponse, AllBundlesVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AllBundlesResponse, AllBundlesVariables>(AllBundlesDocument, options);
}
export function useAllBundlesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AllBundlesResponse, AllBundlesVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AllBundlesResponse, AllBundlesVariables>(AllBundlesDocument, options);
}
export type AllBundlesHookResult = ReturnType<typeof useAllBundles>;
export type AllBundlesLazyQueryHookResult = ReturnType<typeof useAllBundlesLazyQuery>;
export type AllBundlesQueryResult = Apollo.QueryResult<AllBundlesResponse, AllBundlesVariables>;
export const AllOrdersDocument = gql`
  query AllOrders(
    $userId: String!
    $shopName: String
    $bundleStatus: BundleStatus
    $searchQuery: String
    $limit: Int
    $offset: Int
  ) {
    orders(
      sharetribeBuyerId: $userId
      shopName: $shopName
      bundleStatus: $bundleStatus
      searchQuery: $searchQuery
      limit: $limit
      offset: $offset
    ) {
      ...CoreOrder
    }
  }
  ${CoreOrder}
`;

/**
 * __useAllOrders__
 *
 * To run a query within a React component, call `useAllOrders` and pass it any options that fit your needs.
 * When your component renders, `useAllOrders` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllOrders({
 *   variables: {
 *      userId: // value for 'userId'
 *      shopName: // value for 'shopName'
 *      bundleStatus: // value for 'bundleStatus'
 *      searchQuery: // value for 'searchQuery'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useAllOrders(
  baseOptions: Apollo.QueryHookOptions<AllOrdersResponse, AllOrdersVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AllOrdersResponse, AllOrdersVariables>(AllOrdersDocument, options);
}
export function useAllOrdersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AllOrdersResponse, AllOrdersVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AllOrdersResponse, AllOrdersVariables>(AllOrdersDocument, options);
}
export type AllOrdersHookResult = ReturnType<typeof useAllOrders>;
export type AllOrdersLazyQueryHookResult = ReturnType<typeof useAllOrdersLazyQuery>;
export type AllOrdersQueryResult = Apollo.QueryResult<AllOrdersResponse, AllOrdersVariables>;
export const AllShipmentCarriersDocument = gql`
  query AllShipmentCarriers {
    couriers {
      slug
      name
      otherName
      webUrl
      serviceFromCountryRegions
    }
  }
`;

/**
 * __useAllShipmentCarriers__
 *
 * To run a query within a React component, call `useAllShipmentCarriers` and pass it any options that fit your needs.
 * When your component renders, `useAllShipmentCarriers` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllShipmentCarriers({
 *   variables: {
 *   },
 * });
 */
export function useAllShipmentCarriers(
  baseOptions?: Apollo.QueryHookOptions<AllShipmentCarriersResponse, AllShipmentCarriersVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AllShipmentCarriersResponse, AllShipmentCarriersVariables>(
    AllShipmentCarriersDocument,
    options
  );
}
export function useAllShipmentCarriersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AllShipmentCarriersResponse,
    AllShipmentCarriersVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AllShipmentCarriersResponse, AllShipmentCarriersVariables>(
    AllShipmentCarriersDocument,
    options
  );
}
export type AllShipmentCarriersHookResult = ReturnType<typeof useAllShipmentCarriers>;
export type AllShipmentCarriersLazyQueryHookResult = ReturnType<
  typeof useAllShipmentCarriersLazyQuery
>;
export type AllShipmentCarriersQueryResult = Apollo.QueryResult<
  AllShipmentCarriersResponse,
  AllShipmentCarriersVariables
>;
export const BundleByIdDocument = gql`
  query BundleById($bundleId: String!) {
    bundle(id: $bundleId) {
      ...CoreBundle
    }
  }
  ${CoreBundle}
`;

/**
 * __useBundleById__
 *
 * To run a query within a React component, call `useBundleById` and pass it any options that fit your needs.
 * When your component renders, `useBundleById` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBundleById({
 *   variables: {
 *      bundleId: // value for 'bundleId'
 *   },
 * });
 */
export function useBundleById(
  baseOptions: Apollo.QueryHookOptions<BundleByIdResponse, BundleByIdVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<BundleByIdResponse, BundleByIdVariables>(BundleByIdDocument, options);
}
export function useBundleByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<BundleByIdResponse, BundleByIdVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<BundleByIdResponse, BundleByIdVariables>(BundleByIdDocument, options);
}
export type BundleByIdHookResult = ReturnType<typeof useBundleById>;
export type BundleByIdLazyQueryHookResult = ReturnType<typeof useBundleByIdLazyQuery>;
export type BundleByIdQueryResult = Apollo.QueryResult<BundleByIdResponse, BundleByIdVariables>;
export const BundleByIdWithOrderShippingAddressDocument = gql`
  query BundleByIdWithOrderShippingAddress($bundleId: String!, $isReturn: Boolean!) {
    bundle(id: $bundleId) {
      ...CoreBundle
      shipFromAddress @include(if: $isReturn) {
        ...CoreAddress
      }
      order {
        shippingAddress @skip(if: $isReturn) {
          ...CoreAddress
        }
      }
    }
  }
  ${CoreBundle}
  ${CoreAddress}
`;

/**
 * __useBundleByIdWithOrderShippingAddress__
 *
 * To run a query within a React component, call `useBundleByIdWithOrderShippingAddress` and pass it any options that fit your needs.
 * When your component renders, `useBundleByIdWithOrderShippingAddress` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBundleByIdWithOrderShippingAddress({
 *   variables: {
 *      bundleId: // value for 'bundleId'
 *      isReturn: // value for 'isReturn'
 *   },
 * });
 */
export function useBundleByIdWithOrderShippingAddress(
  baseOptions: Apollo.QueryHookOptions<
    BundleByIdWithOrderShippingAddressResponse,
    BundleByIdWithOrderShippingAddressVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BundleByIdWithOrderShippingAddressResponse,
    BundleByIdWithOrderShippingAddressVariables
  >(BundleByIdWithOrderShippingAddressDocument, options);
}
export function useBundleByIdWithOrderShippingAddressLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BundleByIdWithOrderShippingAddressResponse,
    BundleByIdWithOrderShippingAddressVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BundleByIdWithOrderShippingAddressResponse,
    BundleByIdWithOrderShippingAddressVariables
  >(BundleByIdWithOrderShippingAddressDocument, options);
}
export type BundleByIdWithOrderShippingAddressHookResult = ReturnType<
  typeof useBundleByIdWithOrderShippingAddress
>;
export type BundleByIdWithOrderShippingAddressLazyQueryHookResult = ReturnType<
  typeof useBundleByIdWithOrderShippingAddressLazyQuery
>;
export type BundleByIdWithOrderShippingAddressQueryResult = Apollo.QueryResult<
  BundleByIdWithOrderShippingAddressResponse,
  BundleByIdWithOrderShippingAddressVariables
>;
export const CartItemsDocument = gql`
  query CartItems {
    cartItems {
      id
      listing {
        id
        sharetribeListingId
      }
    }
  }
`;

/**
 * __useCartItems__
 *
 * To run a query within a React component, call `useCartItems` and pass it any options that fit your needs.
 * When your component renders, `useCartItems` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartItems({
 *   variables: {
 *   },
 * });
 */
export function useCartItems(
  baseOptions?: Apollo.QueryHookOptions<CartItemsResponse, CartItemsVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CartItemsResponse, CartItemsVariables>(CartItemsDocument, options);
}
export function useCartItemsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CartItemsResponse, CartItemsVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CartItemsResponse, CartItemsVariables>(CartItemsDocument, options);
}
export type CartItemsHookResult = ReturnType<typeof useCartItems>;
export type CartItemsLazyQueryHookResult = ReturnType<typeof useCartItemsLazyQuery>;
export type CartItemsQueryResult = Apollo.QueryResult<CartItemsResponse, CartItemsVariables>;
export const CreateCancellationDocument = gql`
  mutation CreateCancellation($input: CreateCancellationInput!) {
    createCancellation(input: $input) {
      cancellation {
        id
      }
    }
  }
`;
export type CreateCancellationMutationFn = Apollo.MutationFunction<
  CreateCancellationResponse,
  CreateCancellationVariables
>;

/**
 * __useCreateCancellation__
 *
 * To run a mutation, you first call `useCreateCancellation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCancellation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCancellation, { data, loading, error }] = useCreateCancellation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCancellation(
  baseOptions?: Apollo.MutationHookOptions<CreateCancellationResponse, CreateCancellationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateCancellationResponse, CreateCancellationVariables>(
    CreateCancellationDocument,
    options
  );
}
export type CreateCancellationHookResult = ReturnType<typeof useCreateCancellation>;
export type CreateCancellationMutationResult = Apollo.MutationResult<CreateCancellationResponse>;
export type CreateCancellationMutationOptions = Apollo.BaseMutationOptions<
  CreateCancellationResponse,
  CreateCancellationVariables
>;
export const CreateCartItemDocument = gql`
  mutation CreateCartItem($input: CreateCartItemInput!) {
    createCartItem(input: $input) {
      id
      listing {
        id
        sharetribeListingId
      }
    }
  }
`;
export type CreateCartItemMutationFn = Apollo.MutationFunction<
  CreateCartItemResponse,
  CreateCartItemVariables
>;

/**
 * __useCreateCartItem__
 *
 * To run a mutation, you first call `useCreateCartItem` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCartItem` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCartItem, { data, loading, error }] = useCreateCartItem({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCartItem(
  baseOptions?: Apollo.MutationHookOptions<CreateCartItemResponse, CreateCartItemVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateCartItemResponse, CreateCartItemVariables>(
    CreateCartItemDocument,
    options
  );
}
export type CreateCartItemHookResult = ReturnType<typeof useCreateCartItem>;
export type CreateCartItemMutationResult = Apollo.MutationResult<CreateCartItemResponse>;
export type CreateCartItemMutationOptions = Apollo.BaseMutationOptions<
  CreateCartItemResponse,
  CreateCartItemVariables
>;
export const UpsertDisputeDocument = gql`
  mutation UpsertDispute($input: UpsertDisputeInput!) {
    upsertDispute(input: $input) {
      dispute {
        id
      }
    }
  }
`;
export type UpsertDisputeMutationFn = Apollo.MutationFunction<
  UpsertDisputeResponse,
  UpsertDisputeVariables
>;

/**
 * __useUpsertDispute__
 *
 * To run a mutation, you first call `useUpsertDispute` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertDispute` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertDispute, { data, loading, error }] = useUpsertDispute({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertDispute(
  baseOptions?: Apollo.MutationHookOptions<UpsertDisputeResponse, UpsertDisputeVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpsertDisputeResponse, UpsertDisputeVariables>(
    UpsertDisputeDocument,
    options
  );
}
export type UpsertDisputeHookResult = ReturnType<typeof useUpsertDispute>;
export type UpsertDisputeMutationResult = Apollo.MutationResult<UpsertDisputeResponse>;
export type UpsertDisputeMutationOptions = Apollo.BaseMutationOptions<
  UpsertDisputeResponse,
  UpsertDisputeVariables
>;
export const CreateFavoritedItemDocument = gql`
  mutation CreateFavoritedItem($input: CreateFavoritedItemInput!) {
    createFavoritedItem(input: $input) {
      favoritedItem {
        userId
        listingId
      }
    }
  }
`;
export type CreateFavoritedItemMutationFn = Apollo.MutationFunction<
  CreateFavoritedItemResponse,
  CreateFavoritedItemVariables
>;

/**
 * __useCreateFavoritedItem__
 *
 * To run a mutation, you first call `useCreateFavoritedItem` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFavoritedItem` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFavoritedItem, { data, loading, error }] = useCreateFavoritedItem({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFavoritedItem(
  baseOptions?: Apollo.MutationHookOptions<
    CreateFavoritedItemResponse,
    CreateFavoritedItemVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateFavoritedItemResponse, CreateFavoritedItemVariables>(
    CreateFavoritedItemDocument,
    options
  );
}
export type CreateFavoritedItemHookResult = ReturnType<typeof useCreateFavoritedItem>;
export type CreateFavoritedItemMutationResult = Apollo.MutationResult<CreateFavoritedItemResponse>;
export type CreateFavoritedItemMutationOptions = Apollo.BaseMutationOptions<
  CreateFavoritedItemResponse,
  CreateFavoritedItemVariables
>;
export const CreateFulfillmentFromTrackingInfoDocument = gql`
  mutation CreateFulfillmentFromTrackingInfo($input: CreateFulfillmentFromTrackingInfoInput!) {
    createFulfillmentFromTrackingInfo(input: $input) {
      id
      returnBundle {
        id
      }
      bundle {
        id
      }
    }
  }
`;
export type CreateFulfillmentFromTrackingInfoMutationFn = Apollo.MutationFunction<
  CreateFulfillmentFromTrackingInfoResponse,
  CreateFulfillmentFromTrackingInfoVariables
>;

/**
 * __useCreateFulfillmentFromTrackingInfo__
 *
 * To run a mutation, you first call `useCreateFulfillmentFromTrackingInfo` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFulfillmentFromTrackingInfo` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFulfillmentFromTrackingInfo, { data, loading, error }] = useCreateFulfillmentFromTrackingInfo({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFulfillmentFromTrackingInfo(
  baseOptions?: Apollo.MutationHookOptions<
    CreateFulfillmentFromTrackingInfoResponse,
    CreateFulfillmentFromTrackingInfoVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateFulfillmentFromTrackingInfoResponse,
    CreateFulfillmentFromTrackingInfoVariables
  >(CreateFulfillmentFromTrackingInfoDocument, options);
}
export type CreateFulfillmentFromTrackingInfoHookResult = ReturnType<
  typeof useCreateFulfillmentFromTrackingInfo
>;
export type CreateFulfillmentFromTrackingInfoMutationResult =
  Apollo.MutationResult<CreateFulfillmentFromTrackingInfoResponse>;
export type CreateFulfillmentFromTrackingInfoMutationOptions = Apollo.BaseMutationOptions<
  CreateFulfillmentFromTrackingInfoResponse,
  CreateFulfillmentFromTrackingInfoVariables
>;
export const UpsertListingDocument = gql`
  mutation UpsertListing($input: UpsertListingInput!) {
    upsertListing(input: $input) {
      listing {
        id
      }
    }
  }
`;
export type UpsertListingMutationFn = Apollo.MutationFunction<
  UpsertListingResponse,
  UpsertListingVariables
>;

/**
 * __useUpsertListing__
 *
 * To run a mutation, you first call `useUpsertListing` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertListing` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertListing, { data, loading, error }] = useUpsertListing({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertListing(
  baseOptions?: Apollo.MutationHookOptions<UpsertListingResponse, UpsertListingVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpsertListingResponse, UpsertListingVariables>(
    UpsertListingDocument,
    options
  );
}
export type UpsertListingHookResult = ReturnType<typeof useUpsertListing>;
export type UpsertListingMutationResult = Apollo.MutationResult<UpsertListingResponse>;
export type UpsertListingMutationOptions = Apollo.BaseMutationOptions<
  UpsertListingResponse,
  UpsertListingVariables
>;
export const CreateListingFeedbackDocument = gql`
  mutation CreateListingFeedback($input: CreateListingFeedbackInput!) {
    createListingFeedback(input: $input) {
      listingFeedback {
        id
      }
    }
  }
`;
export type CreateListingFeedbackMutationFn = Apollo.MutationFunction<
  CreateListingFeedbackResponse,
  CreateListingFeedbackVariables
>;

/**
 * __useCreateListingFeedback__
 *
 * To run a mutation, you first call `useCreateListingFeedback` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateListingFeedback` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createListingFeedback, { data, loading, error }] = useCreateListingFeedback({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateListingFeedback(
  baseOptions?: Apollo.MutationHookOptions<
    CreateListingFeedbackResponse,
    CreateListingFeedbackVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateListingFeedbackResponse, CreateListingFeedbackVariables>(
    CreateListingFeedbackDocument,
    options
  );
}
export type CreateListingFeedbackHookResult = ReturnType<typeof useCreateListingFeedback>;
export type CreateListingFeedbackMutationResult =
  Apollo.MutationResult<CreateListingFeedbackResponse>;
export type CreateListingFeedbackMutationOptions = Apollo.BaseMutationOptions<
  CreateListingFeedbackResponse,
  CreateListingFeedbackVariables
>;
export const CreateUserDocument = gql`
  mutation CreateUser($input: CreateUserInput!) {
    createUser(input: $input) {
      user {
        id
      }
    }
  }
`;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserResponse, CreateUserVariables>;

/**
 * __useCreateUser__
 *
 * To run a mutation, you first call `useCreateUser` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUser` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUser, { data, loading, error }] = useCreateUser({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUser(
  baseOptions?: Apollo.MutationHookOptions<CreateUserResponse, CreateUserVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateUserResponse, CreateUserVariables>(CreateUserDocument, options);
}
export type CreateUserHookResult = ReturnType<typeof useCreateUser>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserResponse>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<
  CreateUserResponse,
  CreateUserVariables
>;
export const CreditCodeByBundleIdDocument = gql`
  query CreditCodeByBundleId($bundleId: String!) {
    bundle(id: $bundleId) {
      id
      creditCode {
        id
        maskedCode
        amount
        type
        currency
        expireAt
      }
    }
  }
`;

/**
 * __useCreditCodeByBundleId__
 *
 * To run a query within a React component, call `useCreditCodeByBundleId` and pass it any options that fit your needs.
 * When your component renders, `useCreditCodeByBundleId` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreditCodeByBundleId({
 *   variables: {
 *      bundleId: // value for 'bundleId'
 *   },
 * });
 */
export function useCreditCodeByBundleId(
  baseOptions: Apollo.QueryHookOptions<CreditCodeByBundleIdResponse, CreditCodeByBundleIdVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CreditCodeByBundleIdResponse, CreditCodeByBundleIdVariables>(
    CreditCodeByBundleIdDocument,
    options
  );
}
export function useCreditCodeByBundleIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CreditCodeByBundleIdResponse,
    CreditCodeByBundleIdVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CreditCodeByBundleIdResponse, CreditCodeByBundleIdVariables>(
    CreditCodeByBundleIdDocument,
    options
  );
}
export type CreditCodeByBundleIdHookResult = ReturnType<typeof useCreditCodeByBundleId>;
export type CreditCodeByBundleIdLazyQueryHookResult = ReturnType<
  typeof useCreditCodeByBundleIdLazyQuery
>;
export type CreditCodeByBundleIdQueryResult = Apollo.QueryResult<
  CreditCodeByBundleIdResponse,
  CreditCodeByBundleIdVariables
>;
export const CurrentUserHasSalesDocument = gql`
  query CurrentUserHasSales {
    currentUser {
      hasSales
    }
  }
`;

/**
 * __useCurrentUserHasSales__
 *
 * To run a query within a React component, call `useCurrentUserHasSales` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserHasSales` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserHasSales({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserHasSales(
  baseOptions?: Apollo.QueryHookOptions<CurrentUserHasSalesResponse, CurrentUserHasSalesVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CurrentUserHasSalesResponse, CurrentUserHasSalesVariables>(
    CurrentUserHasSalesDocument,
    options
  );
}
export function useCurrentUserHasSalesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CurrentUserHasSalesResponse,
    CurrentUserHasSalesVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CurrentUserHasSalesResponse, CurrentUserHasSalesVariables>(
    CurrentUserHasSalesDocument,
    options
  );
}
export type CurrentUserHasSalesHookResult = ReturnType<typeof useCurrentUserHasSales>;
export type CurrentUserHasSalesLazyQueryHookResult = ReturnType<
  typeof useCurrentUserHasSalesLazyQuery
>;
export type CurrentUserHasSalesQueryResult = Apollo.QueryResult<
  CurrentUserHasSalesResponse,
  CurrentUserHasSalesVariables
>;
export const DeleteDraftListingDocument = gql`
  mutation DeleteDraftListing($input: DraftListingInput!) {
    deleteDraftListing(input: $input) {
      id
    }
  }
`;
export type DeleteDraftListingMutationFn = Apollo.MutationFunction<
  DeleteDraftListingResponse,
  DeleteDraftListingVariables
>;

/**
 * __useDeleteDraftListing__
 *
 * To run a mutation, you first call `useDeleteDraftListing` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDraftListing` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDraftListing, { data, loading, error }] = useDeleteDraftListing({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteDraftListing(
  baseOptions?: Apollo.MutationHookOptions<DeleteDraftListingResponse, DeleteDraftListingVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteDraftListingResponse, DeleteDraftListingVariables>(
    DeleteDraftListingDocument,
    options
  );
}
export type DeleteDraftListingHookResult = ReturnType<typeof useDeleteDraftListing>;
export type DeleteDraftListingMutationResult = Apollo.MutationResult<DeleteDraftListingResponse>;
export type DeleteDraftListingMutationOptions = Apollo.BaseMutationOptions<
  DeleteDraftListingResponse,
  DeleteDraftListingVariables
>;
export const DisbursementByIdDocument = gql`
  query DisbursementById($disbursementId: String!) {
    disbursement(id: $disbursementId) {
      id
      startDate
      endDate
      type
      status
      currency
      discountsTotal
      returnInsuranceTotal
      shippingTotal
      taxTotal
      customerPaidTotal
      peerCashSalesGMVTotal
      peerCreditSalesGMVTotal
      brandDirectSalesGMVTotal
      relistedTradeInSalesGMVTotal
      grossMerchandiseValueTotal
      peerSellerPayoutTotal
      treetTakeTotal
      ccProcessingTotal
      brandCoveredDiscountsTotal
      salesCostTotal
      reimbursedShippingCostTotal
      additionalLineItems
      reimbursementsTotal
      returnShippingCostTotal
      brandCoveredShippingCostTotal
      additionalCostsTotal
      brandDirectSalesPayoutTotal
      relistedTradeInSalesPayoutTotal
      previouslyDepositedTotal
      grossMarginTotal
      earningsTotal
      finalDepositTotal
    }
  }
`;

/**
 * __useDisbursementById__
 *
 * To run a query within a React component, call `useDisbursementById` and pass it any options that fit your needs.
 * When your component renders, `useDisbursementById` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDisbursementById({
 *   variables: {
 *      disbursementId: // value for 'disbursementId'
 *   },
 * });
 */
export function useDisbursementById(
  baseOptions: Apollo.QueryHookOptions<DisbursementByIdResponse, DisbursementByIdVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DisbursementByIdResponse, DisbursementByIdVariables>(
    DisbursementByIdDocument,
    options
  );
}
export function useDisbursementByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<DisbursementByIdResponse, DisbursementByIdVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DisbursementByIdResponse, DisbursementByIdVariables>(
    DisbursementByIdDocument,
    options
  );
}
export type DisbursementByIdHookResult = ReturnType<typeof useDisbursementById>;
export type DisbursementByIdLazyQueryHookResult = ReturnType<typeof useDisbursementByIdLazyQuery>;
export type DisbursementByIdQueryResult = Apollo.QueryResult<
  DisbursementByIdResponse,
  DisbursementByIdVariables
>;
export const DraftListingDocument = gql`
  query DraftListing($input: DraftListingInput!) {
    draftListing(input: $input) {
      ...CoreDraftListing
    }
  }
  ${CoreDraftListing}
`;

/**
 * __useDraftListing__
 *
 * To run a query within a React component, call `useDraftListing` and pass it any options that fit your needs.
 * When your component renders, `useDraftListing` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDraftListing({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDraftListing(
  baseOptions: Apollo.QueryHookOptions<DraftListingResponse, DraftListingVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DraftListingResponse, DraftListingVariables>(
    DraftListingDocument,
    options
  );
}
export function useDraftListingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<DraftListingResponse, DraftListingVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DraftListingResponse, DraftListingVariables>(
    DraftListingDocument,
    options
  );
}
export type DraftListingHookResult = ReturnType<typeof useDraftListing>;
export type DraftListingLazyQueryHookResult = ReturnType<typeof useDraftListingLazyQuery>;
export type DraftListingQueryResult = Apollo.QueryResult<
  DraftListingResponse,
  DraftListingVariables
>;
export const DraftListingsDocument = gql`
  query DraftListings($input: DraftListingFilterInput) {
    draftListings(input: $input) {
      ...CoreDraftListing
    }
  }
  ${CoreDraftListing}
`;

/**
 * __useDraftListings__
 *
 * To run a query within a React component, call `useDraftListings` and pass it any options that fit your needs.
 * When your component renders, `useDraftListings` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDraftListings({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDraftListings(
  baseOptions?: Apollo.QueryHookOptions<DraftListingsResponse, DraftListingsVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DraftListingsResponse, DraftListingsVariables>(
    DraftListingsDocument,
    options
  );
}
export function useDraftListingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<DraftListingsResponse, DraftListingsVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DraftListingsResponse, DraftListingsVariables>(
    DraftListingsDocument,
    options
  );
}
export type DraftListingsHookResult = ReturnType<typeof useDraftListings>;
export type DraftListingsLazyQueryHookResult = ReturnType<typeof useDraftListingsLazyQuery>;
export type DraftListingsQueryResult = Apollo.QueryResult<
  DraftListingsResponse,
  DraftListingsVariables
>;
export const FavoritedItemsDocument = gql`
  query FavoritedItems($treetId: String!) {
    favoritedItems(treetId: $treetId) {
      id
      listing {
        id
        sharetribeListingId
      }
    }
  }
`;

/**
 * __useFavoritedItems__
 *
 * To run a query within a React component, call `useFavoritedItems` and pass it any options that fit your needs.
 * When your component renders, `useFavoritedItems` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFavoritedItems({
 *   variables: {
 *      treetId: // value for 'treetId'
 *   },
 * });
 */
export function useFavoritedItems(
  baseOptions: Apollo.QueryHookOptions<FavoritedItemsResponse, FavoritedItemsVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FavoritedItemsResponse, FavoritedItemsVariables>(
    FavoritedItemsDocument,
    options
  );
}
export function useFavoritedItemsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<FavoritedItemsResponse, FavoritedItemsVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<FavoritedItemsResponse, FavoritedItemsVariables>(
    FavoritedItemsDocument,
    options
  );
}
export type FavoritedItemsHookResult = ReturnType<typeof useFavoritedItems>;
export type FavoritedItemsLazyQueryHookResult = ReturnType<typeof useFavoritedItemsLazyQuery>;
export type FavoritedItemsQueryResult = Apollo.QueryResult<
  FavoritedItemsResponse,
  FavoritedItemsVariables
>;
export const GetBundleShipFromAddressDocument = gql`
  query GetBundleShipFromAddress($bundleId: String!) {
    bundle(id: $bundleId) {
      shipFromAddress {
        id
        addressLine1
        addressLine2
        city
        country
        fullName
        phone
        zip
        state
      }
    }
  }
`;

/**
 * __useGetBundleShipFromAddress__
 *
 * To run a query within a React component, call `useGetBundleShipFromAddress` and pass it any options that fit your needs.
 * When your component renders, `useGetBundleShipFromAddress` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBundleShipFromAddress({
 *   variables: {
 *      bundleId: // value for 'bundleId'
 *   },
 * });
 */
export function useGetBundleShipFromAddress(
  baseOptions: Apollo.QueryHookOptions<
    GetBundleShipFromAddressResponse,
    GetBundleShipFromAddressVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetBundleShipFromAddressResponse, GetBundleShipFromAddressVariables>(
    GetBundleShipFromAddressDocument,
    options
  );
}
export function useGetBundleShipFromAddressLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetBundleShipFromAddressResponse,
    GetBundleShipFromAddressVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetBundleShipFromAddressResponse, GetBundleShipFromAddressVariables>(
    GetBundleShipFromAddressDocument,
    options
  );
}
export type GetBundleShipFromAddressHookResult = ReturnType<typeof useGetBundleShipFromAddress>;
export type GetBundleShipFromAddressLazyQueryHookResult = ReturnType<
  typeof useGetBundleShipFromAddressLazyQuery
>;
export type GetBundleShipFromAddressQueryResult = Apollo.QueryResult<
  GetBundleShipFromAddressResponse,
  GetBundleShipFromAddressVariables
>;
export const ListingsDocument = gql`
  query Listings($input: ListingsInput) {
    listings(input: $input) {
      ...CoreListing
    }
  }
  ${CoreListing}
`;

/**
 * __useListings__
 *
 * To run a query within a React component, call `useListings` and pass it any options that fit your needs.
 * When your component renders, `useListings` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListings({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListings(
  baseOptions?: Apollo.QueryHookOptions<ListingsResponse, ListingsVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListingsResponse, ListingsVariables>(ListingsDocument, options);
}
export function useListingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListingsResponse, ListingsVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListingsResponse, ListingsVariables>(ListingsDocument, options);
}
export type ListingsHookResult = ReturnType<typeof useListings>;
export type ListingsLazyQueryHookResult = ReturnType<typeof useListingsLazyQuery>;
export type ListingsQueryResult = Apollo.QueryResult<ListingsResponse, ListingsVariables>;
export const ListingsForManagementDocument = gql`
  query ListingsForManagement($input: ListingsInput) {
    listings(input: $input) {
      id
      sharetribeListingId
      canRelist
      lastPurchaseBundleId
      wasCanceled
    }
  }
`;

/**
 * __useListingsForManagement__
 *
 * To run a query within a React component, call `useListingsForManagement` and pass it any options that fit your needs.
 * When your component renders, `useListingsForManagement` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingsForManagement({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListingsForManagement(
  baseOptions?: Apollo.QueryHookOptions<
    ListingsForManagementResponse,
    ListingsForManagementVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListingsForManagementResponse, ListingsForManagementVariables>(
    ListingsForManagementDocument,
    options
  );
}
export function useListingsForManagementLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListingsForManagementResponse,
    ListingsForManagementVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListingsForManagementResponse, ListingsForManagementVariables>(
    ListingsForManagementDocument,
    options
  );
}
export type ListingsForManagementHookResult = ReturnType<typeof useListingsForManagement>;
export type ListingsForManagementLazyQueryHookResult = ReturnType<
  typeof useListingsForManagementLazyQuery
>;
export type ListingsForManagementQueryResult = Apollo.QueryResult<
  ListingsForManagementResponse,
  ListingsForManagementVariables
>;
export const ListingsFullyPopulatedDocument = gql`
  query ListingsFullyPopulated($input: ListingsInput) {
    listings(input: $input) {
      ...CoreListing
      creditBoostPromoId
      internalNotes
      payoutInfo
    }
  }
  ${CoreListing}
`;

/**
 * __useListingsFullyPopulated__
 *
 * To run a query within a React component, call `useListingsFullyPopulated` and pass it any options that fit your needs.
 * When your component renders, `useListingsFullyPopulated` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingsFullyPopulated({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListingsFullyPopulated(
  baseOptions?: Apollo.QueryHookOptions<
    ListingsFullyPopulatedResponse,
    ListingsFullyPopulatedVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListingsFullyPopulatedResponse, ListingsFullyPopulatedVariables>(
    ListingsFullyPopulatedDocument,
    options
  );
}
export function useListingsFullyPopulatedLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListingsFullyPopulatedResponse,
    ListingsFullyPopulatedVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListingsFullyPopulatedResponse, ListingsFullyPopulatedVariables>(
    ListingsFullyPopulatedDocument,
    options
  );
}
export type ListingsFullyPopulatedHookResult = ReturnType<typeof useListingsFullyPopulated>;
export type ListingsFullyPopulatedLazyQueryHookResult = ReturnType<
  typeof useListingsFullyPopulatedLazyQuery
>;
export type ListingsFullyPopulatedQueryResult = Apollo.QueryResult<
  ListingsFullyPopulatedResponse,
  ListingsFullyPopulatedVariables
>;
export const LoyaltyProgramByTreetIdDocument = gql`
  query LoyaltyProgramByTreetId($treetId: String!) {
    shop(treetId: $treetId) {
      loyaltyProgram {
        pointsPerMoneyUnit
        pointsName
        programName
        programUrl
      }
    }
  }
`;

/**
 * __useLoyaltyProgramByTreetId__
 *
 * To run a query within a React component, call `useLoyaltyProgramByTreetId` and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyProgramByTreetId` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoyaltyProgramByTreetId({
 *   variables: {
 *      treetId: // value for 'treetId'
 *   },
 * });
 */
export function useLoyaltyProgramByTreetId(
  baseOptions: Apollo.QueryHookOptions<
    LoyaltyProgramByTreetIdResponse,
    LoyaltyProgramByTreetIdVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LoyaltyProgramByTreetIdResponse, LoyaltyProgramByTreetIdVariables>(
    LoyaltyProgramByTreetIdDocument,
    options
  );
}
export function useLoyaltyProgramByTreetIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LoyaltyProgramByTreetIdResponse,
    LoyaltyProgramByTreetIdVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<LoyaltyProgramByTreetIdResponse, LoyaltyProgramByTreetIdVariables>(
    LoyaltyProgramByTreetIdDocument,
    options
  );
}
export type LoyaltyProgramByTreetIdHookResult = ReturnType<typeof useLoyaltyProgramByTreetId>;
export type LoyaltyProgramByTreetIdLazyQueryHookResult = ReturnType<
  typeof useLoyaltyProgramByTreetIdLazyQuery
>;
export type LoyaltyProgramByTreetIdQueryResult = Apollo.QueryResult<
  LoyaltyProgramByTreetIdResponse,
  LoyaltyProgramByTreetIdVariables
>;
export const OrderByIdDocument = gql`
  query OrderById($orderId: String!) {
    order(id: $orderId) {
      sharetribeBuyerId
      shippingAddress {
        id
        fullName
        addressLine1
        addressLine2
        city
        country
        state
        zip
      }
      bundles {
        id
        sharetribeTransactionIds
        status
        fulfillment {
          id
        }
        lineItems {
          ...CoreLineItem
        }
        bundleItems {
          id
          listing {
            id
            sharetribeListingId
          }
        }
      }
    }
  }
  ${CoreLineItem}
`;

/**
 * __useOrderById__
 *
 * To run a query within a React component, call `useOrderById` and pass it any options that fit your needs.
 * When your component renders, `useOrderById` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderById({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useOrderById(
  baseOptions: Apollo.QueryHookOptions<OrderByIdResponse, OrderByIdVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<OrderByIdResponse, OrderByIdVariables>(OrderByIdDocument, options);
}
export function useOrderByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<OrderByIdResponse, OrderByIdVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<OrderByIdResponse, OrderByIdVariables>(OrderByIdDocument, options);
}
export type OrderByIdHookResult = ReturnType<typeof useOrderById>;
export type OrderByIdLazyQueryHookResult = ReturnType<typeof useOrderByIdLazyQuery>;
export type OrderByIdQueryResult = Apollo.QueryResult<OrderByIdResponse, OrderByIdVariables>;
export const ProductsByShopIdDocument = gql`
  query ProductsByShopId(
    $shopId: String!
    $search: String
    $cursor: String
    $take: Int
    $productType: String
  ) {
    products(
      shopId: $shopId
      search: $search
      cursor: $cursor
      take: $take
      productType: $productType
    ) {
      pageInfo {
        hasNext
        endCursor
        take
      }
      products {
        ...CorePartialProduct
      }
    }
  }
  ${CorePartialProduct}
`;

/**
 * __useProductsByShopId__
 *
 * To run a query within a React component, call `useProductsByShopId` and pass it any options that fit your needs.
 * When your component renders, `useProductsByShopId` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsByShopId({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      search: // value for 'search'
 *      cursor: // value for 'cursor'
 *      take: // value for 'take'
 *      productType: // value for 'productType'
 *   },
 * });
 */
export function useProductsByShopId(
  baseOptions: Apollo.QueryHookOptions<ProductsByShopIdResponse, ProductsByShopIdVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ProductsByShopIdResponse, ProductsByShopIdVariables>(
    ProductsByShopIdDocument,
    options
  );
}
export function useProductsByShopIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ProductsByShopIdResponse, ProductsByShopIdVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ProductsByShopIdResponse, ProductsByShopIdVariables>(
    ProductsByShopIdDocument,
    options
  );
}
export type ProductsByShopIdHookResult = ReturnType<typeof useProductsByShopId>;
export type ProductsByShopIdLazyQueryHookResult = ReturnType<typeof useProductsByShopIdLazyQuery>;
export type ProductsByShopIdQueryResult = Apollo.QueryResult<
  ProductsByShopIdResponse,
  ProductsByShopIdVariables
>;
export const GetOrderProductsDocument = gql`
  query GetOrderProducts($treetId: String!, $countryCode: String!, $cursor: String) {
    getOrderProducts(treetId: $treetId, countryCode: $countryCode, cursor: $cursor) {
      pageInfo {
        endCursor
        hasNext
      }
      orderProducts {
        orderNumber
        orderDate
        products {
          id
          title
          description
          tags
          productType
          productMedia {
            id
            orderIndex
            media {
              id
              cdnUrl
            }
          }
          productVariant {
            id
            price
            compareAtPrice
            currency
            selectedVariantOptions
            sku
            weight
            weightUnit
            barcode
            productMedia {
              id
              orderIndex
              media {
                id
                cdnUrl
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetOrderProducts__
 *
 * To run a query within a React component, call `useGetOrderProducts` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderProducts` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderProducts({
 *   variables: {
 *      treetId: // value for 'treetId'
 *      countryCode: // value for 'countryCode'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetOrderProducts(
  baseOptions: Apollo.QueryHookOptions<GetOrderProductsResponse, GetOrderProductsVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetOrderProductsResponse, GetOrderProductsVariables>(
    GetOrderProductsDocument,
    options
  );
}
export function useGetOrderProductsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetOrderProductsResponse, GetOrderProductsVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetOrderProductsResponse, GetOrderProductsVariables>(
    GetOrderProductsDocument,
    options
  );
}
export type GetOrderProductsHookResult = ReturnType<typeof useGetOrderProducts>;
export type GetOrderProductsLazyQueryHookResult = ReturnType<typeof useGetOrderProductsLazyQuery>;
export type GetOrderProductsQueryResult = Apollo.QueryResult<
  GetOrderProductsResponse,
  GetOrderProductsVariables
>;
export const PublishDraftListingDocument = gql`
  mutation PublishDraftListing($input: DraftListingInput!) {
    publishDraftListing(input: $input) {
      id
    }
  }
`;
export type PublishDraftListingMutationFn = Apollo.MutationFunction<
  PublishDraftListingResponse,
  PublishDraftListingVariables
>;

/**
 * __usePublishDraftListing__
 *
 * To run a mutation, you first call `usePublishDraftListing` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishDraftListing` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishDraftListing, { data, loading, error }] = usePublishDraftListing({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublishDraftListing(
  baseOptions?: Apollo.MutationHookOptions<
    PublishDraftListingResponse,
    PublishDraftListingVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<PublishDraftListingResponse, PublishDraftListingVariables>(
    PublishDraftListingDocument,
    options
  );
}
export type PublishDraftListingHookResult = ReturnType<typeof usePublishDraftListing>;
export type PublishDraftListingMutationResult = Apollo.MutationResult<PublishDraftListingResponse>;
export type PublishDraftListingMutationOptions = Apollo.BaseMutationOptions<
  PublishDraftListingResponse,
  PublishDraftListingVariables
>;
export const RemoveCartItemDocument = gql`
  mutation RemoveCartItem($input: RemoveCartItemsInput!) {
    removeCartItem(input: $input) {
      id
      listing {
        id
        sharetribeListingId
      }
    }
  }
`;
export type RemoveCartItemMutationFn = Apollo.MutationFunction<
  RemoveCartItemResponse,
  RemoveCartItemVariables
>;

/**
 * __useRemoveCartItem__
 *
 * To run a mutation, you first call `useRemoveCartItem` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCartItem` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCartItem, { data, loading, error }] = useRemoveCartItem({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveCartItem(
  baseOptions?: Apollo.MutationHookOptions<RemoveCartItemResponse, RemoveCartItemVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RemoveCartItemResponse, RemoveCartItemVariables>(
    RemoveCartItemDocument,
    options
  );
}
export type RemoveCartItemHookResult = ReturnType<typeof useRemoveCartItem>;
export type RemoveCartItemMutationResult = Apollo.MutationResult<RemoveCartItemResponse>;
export type RemoveCartItemMutationOptions = Apollo.BaseMutationOptions<
  RemoveCartItemResponse,
  RemoveCartItemVariables
>;
export const RemoveFavoritedItemDocument = gql`
  mutation RemoveFavoritedItem($input: RemoveFavoritedItemInput!) {
    removeFavoritedItem(input: $input) {
      favoritedItem {
        userId
        listingId
      }
    }
  }
`;
export type RemoveFavoritedItemMutationFn = Apollo.MutationFunction<
  RemoveFavoritedItemResponse,
  RemoveFavoritedItemVariables
>;

/**
 * __useRemoveFavoritedItem__
 *
 * To run a mutation, you first call `useRemoveFavoritedItem` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFavoritedItem` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFavoritedItem, { data, loading, error }] = useRemoveFavoritedItem({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveFavoritedItem(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveFavoritedItemResponse,
    RemoveFavoritedItemVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RemoveFavoritedItemResponse, RemoveFavoritedItemVariables>(
    RemoveFavoritedItemDocument,
    options
  );
}
export type RemoveFavoritedItemHookResult = ReturnType<typeof useRemoveFavoritedItem>;
export type RemoveFavoritedItemMutationResult = Apollo.MutationResult<RemoveFavoritedItemResponse>;
export type RemoveFavoritedItemMutationOptions = Apollo.BaseMutationOptions<
  RemoveFavoritedItemResponse,
  RemoveFavoritedItemVariables
>;
export const SavedSearchByEmailDocument = gql`
  query SavedSearchByEmail($email: String!, $treetId: String!, $type: SavedSearchType!) {
    savedSearch(email: $email, treetId: $treetId, type: $type) {
      id
      search
      cadence
    }
  }
`;

/**
 * __useSavedSearchByEmail__
 *
 * To run a query within a React component, call `useSavedSearchByEmail` and pass it any options that fit your needs.
 * When your component renders, `useSavedSearchByEmail` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSavedSearchByEmail({
 *   variables: {
 *      email: // value for 'email'
 *      treetId: // value for 'treetId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useSavedSearchByEmail(
  baseOptions: Apollo.QueryHookOptions<SavedSearchByEmailResponse, SavedSearchByEmailVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SavedSearchByEmailResponse, SavedSearchByEmailVariables>(
    SavedSearchByEmailDocument,
    options
  );
}
export function useSavedSearchByEmailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SavedSearchByEmailResponse, SavedSearchByEmailVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SavedSearchByEmailResponse, SavedSearchByEmailVariables>(
    SavedSearchByEmailDocument,
    options
  );
}
export type SavedSearchByEmailHookResult = ReturnType<typeof useSavedSearchByEmail>;
export type SavedSearchByEmailLazyQueryHookResult = ReturnType<
  typeof useSavedSearchByEmailLazyQuery
>;
export type SavedSearchByEmailQueryResult = Apollo.QueryResult<
  SavedSearchByEmailResponse,
  SavedSearchByEmailVariables
>;
export const ShopByHostnameDocument = gql`
  query ShopByHostname($hostname: String!) {
    shopByHostname(hostname: $hostname) {
      id
      treetId
      canonicalRootUrl
      defaultCurrency
      primaryLocale
    }
  }
`;

/**
 * __useShopByHostname__
 *
 * To run a query within a React component, call `useShopByHostname` and pass it any options that fit your needs.
 * When your component renders, `useShopByHostname` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShopByHostname({
 *   variables: {
 *      hostname: // value for 'hostname'
 *   },
 * });
 */
export function useShopByHostname(
  baseOptions: Apollo.QueryHookOptions<ShopByHostnameResponse, ShopByHostnameVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ShopByHostnameResponse, ShopByHostnameVariables>(
    ShopByHostnameDocument,
    options
  );
}
export function useShopByHostnameLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ShopByHostnameResponse, ShopByHostnameVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ShopByHostnameResponse, ShopByHostnameVariables>(
    ShopByHostnameDocument,
    options
  );
}
export type ShopByHostnameHookResult = ReturnType<typeof useShopByHostname>;
export type ShopByHostnameLazyQueryHookResult = ReturnType<typeof useShopByHostnameLazyQuery>;
export type ShopByHostnameQueryResult = Apollo.QueryResult<
  ShopByHostnameResponse,
  ShopByHostnameVariables
>;
export const ShopByTreetIdDocument = gql`
  query ShopByTreetId($treetId: String!) {
    shop(treetId: $treetId) {
      id
      canonicalRootUrl
      defaultCurrency
      primaryLocale
    }
  }
`;

/**
 * __useShopByTreetId__
 *
 * To run a query within a React component, call `useShopByTreetId` and pass it any options that fit your needs.
 * When your component renders, `useShopByTreetId` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShopByTreetId({
 *   variables: {
 *      treetId: // value for 'treetId'
 *   },
 * });
 */
export function useShopByTreetId(
  baseOptions: Apollo.QueryHookOptions<ShopByTreetIdResponse, ShopByTreetIdVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ShopByTreetIdResponse, ShopByTreetIdVariables>(
    ShopByTreetIdDocument,
    options
  );
}
export function useShopByTreetIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ShopByTreetIdResponse, ShopByTreetIdVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ShopByTreetIdResponse, ShopByTreetIdVariables>(
    ShopByTreetIdDocument,
    options
  );
}
export type ShopByTreetIdHookResult = ReturnType<typeof useShopByTreetId>;
export type ShopByTreetIdLazyQueryHookResult = ReturnType<typeof useShopByTreetIdLazyQuery>;
export type ShopByTreetIdQueryResult = Apollo.QueryResult<
  ShopByTreetIdResponse,
  ShopByTreetIdVariables
>;
export const UpdateAddressDocument = gql`
  mutation UpdateAddress($input: UpdateAddressInput!) {
    updateAddress(input: $input) {
      address {
        ...CoreAddress
      }
    }
  }
  ${CoreAddress}
`;
export type UpdateAddressMutationFn = Apollo.MutationFunction<
  UpdateAddressResponse,
  UpdateAddressVariables
>;

/**
 * __useUpdateAddress__
 *
 * To run a mutation, you first call `useUpdateAddress` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAddress` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAddress, { data, loading, error }] = useUpdateAddress({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAddress(
  baseOptions?: Apollo.MutationHookOptions<UpdateAddressResponse, UpdateAddressVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateAddressResponse, UpdateAddressVariables>(
    UpdateAddressDocument,
    options
  );
}
export type UpdateAddressHookResult = ReturnType<typeof useUpdateAddress>;
export type UpdateAddressMutationResult = Apollo.MutationResult<UpdateAddressResponse>;
export type UpdateAddressMutationOptions = Apollo.BaseMutationOptions<
  UpdateAddressResponse,
  UpdateAddressVariables
>;
export const UpdateBundleDocument = gql`
  mutation UpdateBundle($input: UpdateBundleInput!) {
    updateBundle(input: $input) {
      bundle {
        id
        status
        isMarkedFulfilled
        canceledAt
        expireAt
        lineItems {
          ...CoreLineItem
        }
      }
    }
  }
  ${CoreLineItem}
`;
export type UpdateBundleMutationFn = Apollo.MutationFunction<
  UpdateBundleResponse,
  UpdateBundleVariables
>;

/**
 * __useUpdateBundle__
 *
 * To run a mutation, you first call `useUpdateBundle` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBundle` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBundle, { data, loading, error }] = useUpdateBundle({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBundle(
  baseOptions?: Apollo.MutationHookOptions<UpdateBundleResponse, UpdateBundleVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateBundleResponse, UpdateBundleVariables>(
    UpdateBundleDocument,
    options
  );
}
export type UpdateBundleHookResult = ReturnType<typeof useUpdateBundle>;
export type UpdateBundleMutationResult = Apollo.MutationResult<UpdateBundleResponse>;
export type UpdateBundleMutationOptions = Apollo.BaseMutationOptions<
  UpdateBundleResponse,
  UpdateBundleVariables
>;
export const UpdateBundleItemDocument = gql`
  mutation UpdateBundleItem($input: UpdateBundleItemInput!) {
    updateBundleItem(input: $input) {
      bundleItem {
        id
        status
      }
    }
  }
`;
export type UpdateBundleItemMutationFn = Apollo.MutationFunction<
  UpdateBundleItemResponse,
  UpdateBundleItemVariables
>;

/**
 * __useUpdateBundleItem__
 *
 * To run a mutation, you first call `useUpdateBundleItem` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBundleItem` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBundleItem, { data, loading, error }] = useUpdateBundleItem({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBundleItem(
  baseOptions?: Apollo.MutationHookOptions<UpdateBundleItemResponse, UpdateBundleItemVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateBundleItemResponse, UpdateBundleItemVariables>(
    UpdateBundleItemDocument,
    options
  );
}
export type UpdateBundleItemHookResult = ReturnType<typeof useUpdateBundleItem>;
export type UpdateBundleItemMutationResult = Apollo.MutationResult<UpdateBundleItemResponse>;
export type UpdateBundleItemMutationOptions = Apollo.BaseMutationOptions<
  UpdateBundleItemResponse,
  UpdateBundleItemVariables
>;
export const UpdateUserDocument = gql`
  mutation UpdateUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      user {
        email
        stripeAccountId
      }
    }
  }
`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserResponse, UpdateUserVariables>;

/**
 * __useUpdateUser__
 *
 * To run a mutation, you first call `useUpdateUser` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUser` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUser, { data, loading, error }] = useUpdateUser({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUser(
  baseOptions?: Apollo.MutationHookOptions<UpdateUserResponse, UpdateUserVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateUserResponse, UpdateUserVariables>(UpdateUserDocument, options);
}
export type UpdateUserHookResult = ReturnType<typeof useUpdateUser>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserResponse>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserResponse,
  UpdateUserVariables
>;
export const UpsertDraftListingDocument = gql`
  mutation UpsertDraftListing($input: UpsertDraftListingInput!) {
    upsertDraftListing(input: $input) {
      ...CoreDraftListing
    }
  }
  ${CoreDraftListing}
`;
export type UpsertDraftListingMutationFn = Apollo.MutationFunction<
  UpsertDraftListingResponse,
  UpsertDraftListingVariables
>;

/**
 * __useUpsertDraftListing__
 *
 * To run a mutation, you first call `useUpsertDraftListing` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertDraftListing` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertDraftListing, { data, loading, error }] = useUpsertDraftListing({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertDraftListing(
  baseOptions?: Apollo.MutationHookOptions<UpsertDraftListingResponse, UpsertDraftListingVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpsertDraftListingResponse, UpsertDraftListingVariables>(
    UpsertDraftListingDocument,
    options
  );
}
export type UpsertDraftListingHookResult = ReturnType<typeof useUpsertDraftListing>;
export type UpsertDraftListingMutationResult = Apollo.MutationResult<UpsertDraftListingResponse>;
export type UpsertDraftListingMutationOptions = Apollo.BaseMutationOptions<
  UpsertDraftListingResponse,
  UpsertDraftListingVariables
>;
export const UpsertGeneralSavedSearchDocument = gql`
  mutation UpsertGeneralSavedSearch($input: UpsertGeneralSavedSearchInput!) {
    upsertGeneralSavedSearch(input: $input) {
      savedSearch {
        id
        email
        search
        cadence
        shop {
          id
        }
        subscribeSource
      }
    }
  }
`;
export type UpsertGeneralSavedSearchMutationFn = Apollo.MutationFunction<
  UpsertGeneralSavedSearchResponse,
  UpsertGeneralSavedSearchVariables
>;

/**
 * __useUpsertGeneralSavedSearch__
 *
 * To run a mutation, you first call `useUpsertGeneralSavedSearch` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertGeneralSavedSearch` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertGeneralSavedSearch, { data, loading, error }] = useUpsertGeneralSavedSearch({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertGeneralSavedSearch(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertGeneralSavedSearchResponse,
    UpsertGeneralSavedSearchVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpsertGeneralSavedSearchResponse, UpsertGeneralSavedSearchVariables>(
    UpsertGeneralSavedSearchDocument,
    options
  );
}
export type UpsertGeneralSavedSearchHookResult = ReturnType<typeof useUpsertGeneralSavedSearch>;
export type UpsertGeneralSavedSearchMutationResult =
  Apollo.MutationResult<UpsertGeneralSavedSearchResponse>;
export type UpsertGeneralSavedSearchMutationOptions = Apollo.BaseMutationOptions<
  UpsertGeneralSavedSearchResponse,
  UpsertGeneralSavedSearchVariables
>;
export const UpsertIsoSavedSearchDocument = gql`
  mutation UpsertISOSavedSearch($input: UpsertISOSavedSearchInput!) {
    upsertISOSavedSearch(input: $input) {
      savedSearch {
        id
        email
        search
        cadence
        shop {
          id
        }
        subscribeSource
      }
      metadata {
        created
        updated
      }
    }
  }
`;
export type UpsertIsoSavedSearchMutationFn = Apollo.MutationFunction<
  UpsertIsoSavedSearchResponse,
  UpsertIsoSavedSearchVariables
>;

/**
 * __useUpsertIsoSavedSearch__
 *
 * To run a mutation, you first call `useUpsertIsoSavedSearch` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertIsoSavedSearch` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertIsoSavedSearch, { data, loading, error }] = useUpsertIsoSavedSearch({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertIsoSavedSearch(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertIsoSavedSearchResponse,
    UpsertIsoSavedSearchVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpsertIsoSavedSearchResponse, UpsertIsoSavedSearchVariables>(
    UpsertIsoSavedSearchDocument,
    options
  );
}
export type UpsertIsoSavedSearchHookResult = ReturnType<typeof useUpsertIsoSavedSearch>;
export type UpsertIsoSavedSearchMutationResult =
  Apollo.MutationResult<UpsertIsoSavedSearchResponse>;
export type UpsertIsoSavedSearchMutationOptions = Apollo.BaseMutationOptions<
  UpsertIsoSavedSearchResponse,
  UpsertIsoSavedSearchVariables
>;
export const UpsertPhotosOnDraftDocument = gql`
  mutation UpsertPhotosOnDraft($sellerPhotos: [Json!]!, $draftListingId: ID!) {
    upsertPhotosOnDraft(sellerPhotos: $sellerPhotos, draftListingId: $draftListingId) {
      id
      sellerPhotos
    }
  }
`;
export type UpsertPhotosOnDraftMutationFn = Apollo.MutationFunction<
  UpsertPhotosOnDraftResponse,
  UpsertPhotosOnDraftVariables
>;

/**
 * __useUpsertPhotosOnDraft__
 *
 * To run a mutation, you first call `useUpsertPhotosOnDraft` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPhotosOnDraft` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPhotosOnDraft, { data, loading, error }] = useUpsertPhotosOnDraft({
 *   variables: {
 *      sellerPhotos: // value for 'sellerPhotos'
 *      draftListingId: // value for 'draftListingId'
 *   },
 * });
 */
export function useUpsertPhotosOnDraft(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertPhotosOnDraftResponse,
    UpsertPhotosOnDraftVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpsertPhotosOnDraftResponse, UpsertPhotosOnDraftVariables>(
    UpsertPhotosOnDraftDocument,
    options
  );
}
export type UpsertPhotosOnDraftHookResult = ReturnType<typeof useUpsertPhotosOnDraft>;
export type UpsertPhotosOnDraftMutationResult = Apollo.MutationResult<UpsertPhotosOnDraftResponse>;
export type UpsertPhotosOnDraftMutationOptions = Apollo.BaseMutationOptions<
  UpsertPhotosOnDraftResponse,
  UpsertPhotosOnDraftVariables
>;
export const UpsertPriceDropConfigDocument = gql`
  mutation UpsertPriceDropConfig($input: UpsertPriceDropConfigInput!) {
    upsertPriceDropConfig(input: $input) {
      priceDropConfig {
        id
        isActive
        minPrice
        nextScheduledDrop
        percentageDrop
        anchorPrice
      }
    }
  }
`;
export type UpsertPriceDropConfigMutationFn = Apollo.MutationFunction<
  UpsertPriceDropConfigResponse,
  UpsertPriceDropConfigVariables
>;

/**
 * __useUpsertPriceDropConfig__
 *
 * To run a mutation, you first call `useUpsertPriceDropConfig` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPriceDropConfig` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPriceDropConfig, { data, loading, error }] = useUpsertPriceDropConfig({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertPriceDropConfig(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertPriceDropConfigResponse,
    UpsertPriceDropConfigVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpsertPriceDropConfigResponse, UpsertPriceDropConfigVariables>(
    UpsertPriceDropConfigDocument,
    options
  );
}
export type UpsertPriceDropConfigHookResult = ReturnType<typeof useUpsertPriceDropConfig>;
export type UpsertPriceDropConfigMutationResult =
  Apollo.MutationResult<UpsertPriceDropConfigResponse>;
export type UpsertPriceDropConfigMutationOptions = Apollo.BaseMutationOptions<
  UpsertPriceDropConfigResponse,
  UpsertPriceDropConfigVariables
>;
export const UpdateUserShipFromCountryDocument = gql`
  mutation UpdateUserShipFromCountry($input: UpdateUserShipFromCountryInput!) {
    updateUserShipFromCountry(input: $input) {
      shipFromCountry
    }
  }
`;
export type UpdateUserShipFromCountryMutationFn = Apollo.MutationFunction<
  UpdateUserShipFromCountryResponse,
  UpdateUserShipFromCountryVariables
>;

/**
 * __useUpdateUserShipFromCountry__
 *
 * To run a mutation, you first call `useUpdateUserShipFromCountry` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserShipFromCountry` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserShipFromCountry, { data, loading, error }] = useUpdateUserShipFromCountry({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserShipFromCountry(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUserShipFromCountryResponse,
    UpdateUserShipFromCountryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateUserShipFromCountryResponse, UpdateUserShipFromCountryVariables>(
    UpdateUserShipFromCountryDocument,
    options
  );
}
export type UpdateUserShipFromCountryHookResult = ReturnType<typeof useUpdateUserShipFromCountry>;
export type UpdateUserShipFromCountryMutationResult =
  Apollo.MutationResult<UpdateUserShipFromCountryResponse>;
export type UpdateUserShipFromCountryMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserShipFromCountryResponse,
  UpdateUserShipFromCountryVariables
>;
export const ShopIntegrationsByShopIdDocument = gql`
  query ShopIntegrationsByShopId($shopId: String!) {
    shopIntegrations(shopId: $shopId) {
      id
      tier
      title
      subtitle
      description
      detailedDescription
      integrationTarget {
        iconUrl
      }
      integrationType
      tags {
        key
        title
      }
      integration {
        installed
      }
      configuration {
        isActive
      }
    }
  }
`;

/**
 * __useShopIntegrationsByShopId__
 *
 * To run a query within a React component, call `useShopIntegrationsByShopId` and pass it any options that fit your needs.
 * When your component renders, `useShopIntegrationsByShopId` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShopIntegrationsByShopId({
 *   variables: {
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useShopIntegrationsByShopId(
  baseOptions: Apollo.QueryHookOptions<
    ShopIntegrationsByShopIdResponse,
    ShopIntegrationsByShopIdVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ShopIntegrationsByShopIdResponse, ShopIntegrationsByShopIdVariables>(
    ShopIntegrationsByShopIdDocument,
    options
  );
}
export function useShopIntegrationsByShopIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ShopIntegrationsByShopIdResponse,
    ShopIntegrationsByShopIdVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ShopIntegrationsByShopIdResponse, ShopIntegrationsByShopIdVariables>(
    ShopIntegrationsByShopIdDocument,
    options
  );
}
export type ShopIntegrationsByShopIdHookResult = ReturnType<typeof useShopIntegrationsByShopId>;
export type ShopIntegrationsByShopIdLazyQueryHookResult = ReturnType<
  typeof useShopIntegrationsByShopIdLazyQuery
>;
export type ShopIntegrationsByShopIdQueryResult = Apollo.QueryResult<
  ShopIntegrationsByShopIdResponse,
  ShopIntegrationsByShopIdVariables
>;
export const ShopIntegrationByShopIdAndIntegrationTypeDocument = gql`
  query ShopIntegrationByShopIdAndIntegrationType(
    $shopId: String!
    $integrationType: ShopIntegrationType!
  ) {
    shopIntegration(shopId: $shopId, integrationType: $integrationType) {
      ...CoreShopIntegration
    }
  }
  ${CoreShopIntegration}
`;

/**
 * __useShopIntegrationByShopIdAndIntegrationType__
 *
 * To run a query within a React component, call `useShopIntegrationByShopIdAndIntegrationType` and pass it any options that fit your needs.
 * When your component renders, `useShopIntegrationByShopIdAndIntegrationType` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShopIntegrationByShopIdAndIntegrationType({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      integrationType: // value for 'integrationType'
 *   },
 * });
 */
export function useShopIntegrationByShopIdAndIntegrationType(
  baseOptions: Apollo.QueryHookOptions<
    ShopIntegrationByShopIdAndIntegrationTypeResponse,
    ShopIntegrationByShopIdAndIntegrationTypeVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ShopIntegrationByShopIdAndIntegrationTypeResponse,
    ShopIntegrationByShopIdAndIntegrationTypeVariables
  >(ShopIntegrationByShopIdAndIntegrationTypeDocument, options);
}
export function useShopIntegrationByShopIdAndIntegrationTypeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ShopIntegrationByShopIdAndIntegrationTypeResponse,
    ShopIntegrationByShopIdAndIntegrationTypeVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ShopIntegrationByShopIdAndIntegrationTypeResponse,
    ShopIntegrationByShopIdAndIntegrationTypeVariables
  >(ShopIntegrationByShopIdAndIntegrationTypeDocument, options);
}
export type ShopIntegrationByShopIdAndIntegrationTypeHookResult = ReturnType<
  typeof useShopIntegrationByShopIdAndIntegrationType
>;
export type ShopIntegrationByShopIdAndIntegrationTypeLazyQueryHookResult = ReturnType<
  typeof useShopIntegrationByShopIdAndIntegrationTypeLazyQuery
>;
export type ShopIntegrationByShopIdAndIntegrationTypeQueryResult = Apollo.QueryResult<
  ShopIntegrationByShopIdAndIntegrationTypeResponse,
  ShopIntegrationByShopIdAndIntegrationTypeVariables
>;
export const ShopIntegrationInstalledStatusByShopIdAndIntegrationTypeDocument = gql`
  query ShopIntegrationInstalledStatusByShopIdAndIntegrationType(
    $shopId: String!
    $integrationType: ShopIntegrationType!
  ) {
    shopIntegration(shopId: $shopId, integrationType: $integrationType) {
      id
      integration {
        installed
      }
    }
  }
`;

/**
 * __useShopIntegrationInstalledStatusByShopIdAndIntegrationType__
 *
 * To run a query within a React component, call `useShopIntegrationInstalledStatusByShopIdAndIntegrationType` and pass it any options that fit your needs.
 * When your component renders, `useShopIntegrationInstalledStatusByShopIdAndIntegrationType` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShopIntegrationInstalledStatusByShopIdAndIntegrationType({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      integrationType: // value for 'integrationType'
 *   },
 * });
 */
export function useShopIntegrationInstalledStatusByShopIdAndIntegrationType(
  baseOptions: Apollo.QueryHookOptions<
    ShopIntegrationInstalledStatusByShopIdAndIntegrationTypeResponse,
    ShopIntegrationInstalledStatusByShopIdAndIntegrationTypeVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ShopIntegrationInstalledStatusByShopIdAndIntegrationTypeResponse,
    ShopIntegrationInstalledStatusByShopIdAndIntegrationTypeVariables
  >(ShopIntegrationInstalledStatusByShopIdAndIntegrationTypeDocument, options);
}
export function useShopIntegrationInstalledStatusByShopIdAndIntegrationTypeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ShopIntegrationInstalledStatusByShopIdAndIntegrationTypeResponse,
    ShopIntegrationInstalledStatusByShopIdAndIntegrationTypeVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ShopIntegrationInstalledStatusByShopIdAndIntegrationTypeResponse,
    ShopIntegrationInstalledStatusByShopIdAndIntegrationTypeVariables
  >(ShopIntegrationInstalledStatusByShopIdAndIntegrationTypeDocument, options);
}
export type ShopIntegrationInstalledStatusByShopIdAndIntegrationTypeHookResult = ReturnType<
  typeof useShopIntegrationInstalledStatusByShopIdAndIntegrationType
>;
export type ShopIntegrationInstalledStatusByShopIdAndIntegrationTypeLazyQueryHookResult =
  ReturnType<typeof useShopIntegrationInstalledStatusByShopIdAndIntegrationTypeLazyQuery>;
export type ShopIntegrationInstalledStatusByShopIdAndIntegrationTypeQueryResult =
  Apollo.QueryResult<
    ShopIntegrationInstalledStatusByShopIdAndIntegrationTypeResponse,
    ShopIntegrationInstalledStatusByShopIdAndIntegrationTypeVariables
  >;
export const ShopAlloyTokenByShopIdDocument = gql`
  query ShopAlloyTokenByShopId($shopId: String!) {
    shopAlloyToken(shopId: $shopId)
  }
`;

/**
 * __useShopAlloyTokenByShopId__
 *
 * To run a query within a React component, call `useShopAlloyTokenByShopId` and pass it any options that fit your needs.
 * When your component renders, `useShopAlloyTokenByShopId` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShopAlloyTokenByShopId({
 *   variables: {
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useShopAlloyTokenByShopId(
  baseOptions: Apollo.QueryHookOptions<
    ShopAlloyTokenByShopIdResponse,
    ShopAlloyTokenByShopIdVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ShopAlloyTokenByShopIdResponse, ShopAlloyTokenByShopIdVariables>(
    ShopAlloyTokenByShopIdDocument,
    options
  );
}
export function useShopAlloyTokenByShopIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ShopAlloyTokenByShopIdResponse,
    ShopAlloyTokenByShopIdVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ShopAlloyTokenByShopIdResponse, ShopAlloyTokenByShopIdVariables>(
    ShopAlloyTokenByShopIdDocument,
    options
  );
}
export type ShopAlloyTokenByShopIdHookResult = ReturnType<typeof useShopAlloyTokenByShopId>;
export type ShopAlloyTokenByShopIdLazyQueryHookResult = ReturnType<
  typeof useShopAlloyTokenByShopIdLazyQuery
>;
export type ShopAlloyTokenByShopIdQueryResult = Apollo.QueryResult<
  ShopAlloyTokenByShopIdResponse,
  ShopAlloyTokenByShopIdVariables
>;
export const UpsertShopIntegrationDocument = gql`
  mutation UpsertShopIntegration($input: ShopIntegrationSaveInput!) {
    saveShopIntegrationConfig(input: $input) {
      validationErrors {
        key
        reason
      }
      configuration {
        id
        isActive
        configuration
      }
    }
  }
`;
export type UpsertShopIntegrationMutationFn = Apollo.MutationFunction<
  UpsertShopIntegrationResponse,
  UpsertShopIntegrationVariables
>;

/**
 * __useUpsertShopIntegration__
 *
 * To run a mutation, you first call `useUpsertShopIntegration` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertShopIntegration` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertShopIntegration, { data, loading, error }] = useUpsertShopIntegration({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertShopIntegration(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertShopIntegrationResponse,
    UpsertShopIntegrationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpsertShopIntegrationResponse, UpsertShopIntegrationVariables>(
    UpsertShopIntegrationDocument,
    options
  );
}
export type UpsertShopIntegrationHookResult = ReturnType<typeof useUpsertShopIntegration>;
export type UpsertShopIntegrationMutationResult =
  Apollo.MutationResult<UpsertShopIntegrationResponse>;
export type UpsertShopIntegrationMutationOptions = Apollo.BaseMutationOptions<
  UpsertShopIntegrationResponse,
  UpsertShopIntegrationVariables
>;
export const BrandHealthActionsDocument = gql`
  query BrandHealthActions {
    brandHealthActions {
      key
      includeForExperiences
      excludeForExperiences
      title
      categories
      impact
      time
    }
  }
`;

/**
 * __useBrandHealthActions__
 *
 * To run a query within a React component, call `useBrandHealthActions` and pass it any options that fit your needs.
 * When your component renders, `useBrandHealthActions` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandHealthActions({
 *   variables: {
 *   },
 * });
 */
export function useBrandHealthActions(
  baseOptions?: Apollo.QueryHookOptions<BrandHealthActionsResponse, BrandHealthActionsVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<BrandHealthActionsResponse, BrandHealthActionsVariables>(
    BrandHealthActionsDocument,
    options
  );
}
export function useBrandHealthActionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<BrandHealthActionsResponse, BrandHealthActionsVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<BrandHealthActionsResponse, BrandHealthActionsVariables>(
    BrandHealthActionsDocument,
    options
  );
}
export type BrandHealthActionsHookResult = ReturnType<typeof useBrandHealthActions>;
export type BrandHealthActionsLazyQueryHookResult = ReturnType<
  typeof useBrandHealthActionsLazyQuery
>;
export type BrandHealthActionsQueryResult = Apollo.QueryResult<
  BrandHealthActionsResponse,
  BrandHealthActionsVariables
>;
export const BrandHealthActionByKeyDocument = gql`
  query BrandHealthActionByKey($key: String!) {
    brandHealthAction(key: $key) {
      key
      title
      categories
      impact
      time
      description
      whyExplainer
      implementationInstructions
      actionButtonText
      actionButtonLink
    }
  }
`;

/**
 * __useBrandHealthActionByKey__
 *
 * To run a query within a React component, call `useBrandHealthActionByKey` and pass it any options that fit your needs.
 * When your component renders, `useBrandHealthActionByKey` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandHealthActionByKey({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useBrandHealthActionByKey(
  baseOptions: Apollo.QueryHookOptions<
    BrandHealthActionByKeyResponse,
    BrandHealthActionByKeyVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<BrandHealthActionByKeyResponse, BrandHealthActionByKeyVariables>(
    BrandHealthActionByKeyDocument,
    options
  );
}
export function useBrandHealthActionByKeyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BrandHealthActionByKeyResponse,
    BrandHealthActionByKeyVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<BrandHealthActionByKeyResponse, BrandHealthActionByKeyVariables>(
    BrandHealthActionByKeyDocument,
    options
  );
}
export type BrandHealthActionByKeyHookResult = ReturnType<typeof useBrandHealthActionByKey>;
export type BrandHealthActionByKeyLazyQueryHookResult = ReturnType<
  typeof useBrandHealthActionByKeyLazyQuery
>;
export type BrandHealthActionByKeyQueryResult = Apollo.QueryResult<
  BrandHealthActionByKeyResponse,
  BrandHealthActionByKeyVariables
>;
export const MostRecentBrandHealthLogByShopIdDocument = gql`
  query MostRecentBrandHealthLogByShopId($shopId: String!) {
    brandHealthLog(shopId: $shopId) {
      id
      createdAt
      inventoryScore
      promotionScore
      overallScore
      inventoryScoreGrade
      promotionScoreGrade
      overallScoreGrade
      actionsTaken
    }
  }
`;

/**
 * __useMostRecentBrandHealthLogByShopId__
 *
 * To run a query within a React component, call `useMostRecentBrandHealthLogByShopId` and pass it any options that fit your needs.
 * When your component renders, `useMostRecentBrandHealthLogByShopId` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMostRecentBrandHealthLogByShopId({
 *   variables: {
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useMostRecentBrandHealthLogByShopId(
  baseOptions: Apollo.QueryHookOptions<
    MostRecentBrandHealthLogByShopIdResponse,
    MostRecentBrandHealthLogByShopIdVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    MostRecentBrandHealthLogByShopIdResponse,
    MostRecentBrandHealthLogByShopIdVariables
  >(MostRecentBrandHealthLogByShopIdDocument, options);
}
export function useMostRecentBrandHealthLogByShopIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MostRecentBrandHealthLogByShopIdResponse,
    MostRecentBrandHealthLogByShopIdVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    MostRecentBrandHealthLogByShopIdResponse,
    MostRecentBrandHealthLogByShopIdVariables
  >(MostRecentBrandHealthLogByShopIdDocument, options);
}
export type MostRecentBrandHealthLogByShopIdHookResult = ReturnType<
  typeof useMostRecentBrandHealthLogByShopId
>;
export type MostRecentBrandHealthLogByShopIdLazyQueryHookResult = ReturnType<
  typeof useMostRecentBrandHealthLogByShopIdLazyQuery
>;
export type MostRecentBrandHealthLogByShopIdQueryResult = Apollo.QueryResult<
  MostRecentBrandHealthLogByShopIdResponse,
  MostRecentBrandHealthLogByShopIdVariables
>;
export const GetPriceDropConfigBySharetribeListingIdDocument = gql`
  query GetPriceDropConfigBySharetribeListingId($sharetribeListingId: ID) {
    priceDropConfig(sharetribeListingId: $sharetribeListingId) {
      id
      anchorPrice
      minPrice
      nextScheduledDrop
      isActive
      percentageDrop
      listingId
    }
  }
`;

/**
 * __useGetPriceDropConfigBySharetribeListingId__
 *
 * To run a query within a React component, call `useGetPriceDropConfigBySharetribeListingId` and pass it any options that fit your needs.
 * When your component renders, `useGetPriceDropConfigBySharetribeListingId` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPriceDropConfigBySharetribeListingId({
 *   variables: {
 *      sharetribeListingId: // value for 'sharetribeListingId'
 *   },
 * });
 */
export function useGetPriceDropConfigBySharetribeListingId(
  baseOptions?: Apollo.QueryHookOptions<
    GetPriceDropConfigBySharetribeListingIdResponse,
    GetPriceDropConfigBySharetribeListingIdVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPriceDropConfigBySharetribeListingIdResponse,
    GetPriceDropConfigBySharetribeListingIdVariables
  >(GetPriceDropConfigBySharetribeListingIdDocument, options);
}
export function useGetPriceDropConfigBySharetribeListingIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPriceDropConfigBySharetribeListingIdResponse,
    GetPriceDropConfigBySharetribeListingIdVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPriceDropConfigBySharetribeListingIdResponse,
    GetPriceDropConfigBySharetribeListingIdVariables
  >(GetPriceDropConfigBySharetribeListingIdDocument, options);
}
export type GetPriceDropConfigBySharetribeListingIdHookResult = ReturnType<
  typeof useGetPriceDropConfigBySharetribeListingId
>;
export type GetPriceDropConfigBySharetribeListingIdLazyQueryHookResult = ReturnType<
  typeof useGetPriceDropConfigBySharetribeListingIdLazyQuery
>;
export type GetPriceDropConfigBySharetribeListingIdQueryResult = Apollo.QueryResult<
  GetPriceDropConfigBySharetribeListingIdResponse,
  GetPriceDropConfigBySharetribeListingIdVariables
>;
export const IsoSavedSearchesByEmailDocument = gql`
  query ISOSavedSearchesByEmail($email: String!, $treetId: String!) {
    isoSavedSearches(email: $email, treetId: $treetId) {
      id
      search
    }
  }
`;

/**
 * __useIsoSavedSearchesByEmail__
 *
 * To run a query within a React component, call `useIsoSavedSearchesByEmail` and pass it any options that fit your needs.
 * When your component renders, `useIsoSavedSearchesByEmail` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsoSavedSearchesByEmail({
 *   variables: {
 *      email: // value for 'email'
 *      treetId: // value for 'treetId'
 *   },
 * });
 */
export function useIsoSavedSearchesByEmail(
  baseOptions: Apollo.QueryHookOptions<
    IsoSavedSearchesByEmailResponse,
    IsoSavedSearchesByEmailVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<IsoSavedSearchesByEmailResponse, IsoSavedSearchesByEmailVariables>(
    IsoSavedSearchesByEmailDocument,
    options
  );
}
export function useIsoSavedSearchesByEmailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IsoSavedSearchesByEmailResponse,
    IsoSavedSearchesByEmailVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<IsoSavedSearchesByEmailResponse, IsoSavedSearchesByEmailVariables>(
    IsoSavedSearchesByEmailDocument,
    options
  );
}
export type IsoSavedSearchesByEmailHookResult = ReturnType<typeof useIsoSavedSearchesByEmail>;
export type IsoSavedSearchesByEmailLazyQueryHookResult = ReturnType<
  typeof useIsoSavedSearchesByEmailLazyQuery
>;
export type IsoSavedSearchesByEmailQueryResult = Apollo.QueryResult<
  IsoSavedSearchesByEmailResponse,
  IsoSavedSearchesByEmailVariables
>;
export const namedOperations = {
  Query: {
    AllBrandDisbursements: 'AllBrandDisbursements',
    AllBrandReports: 'AllBrandReports',
    AllBundles: 'AllBundles',
    AllOrders: 'AllOrders',
    AllShipmentCarriers: 'AllShipmentCarriers',
    BundleById: 'BundleById',
    BundleByIdWithOrderShippingAddress: 'BundleByIdWithOrderShippingAddress',
    CartItems: 'CartItems',
    CreditCodeByBundleId: 'CreditCodeByBundleId',
    CurrentUserHasSales: 'CurrentUserHasSales',
    DisbursementById: 'DisbursementById',
    DraftListing: 'DraftListing',
    DraftListings: 'DraftListings',
    FavoritedItems: 'FavoritedItems',
    GetBundleShipFromAddress: 'GetBundleShipFromAddress',
    Listings: 'Listings',
    ListingsForManagement: 'ListingsForManagement',
    ListingsFullyPopulated: 'ListingsFullyPopulated',
    LoyaltyProgramByTreetId: 'LoyaltyProgramByTreetId',
    OrderById: 'OrderById',
    ProductsByShopId: 'ProductsByShopId',
    GetOrderProducts: 'GetOrderProducts',
    SavedSearchByEmail: 'SavedSearchByEmail',
    ShopByHostname: 'ShopByHostname',
    ShopByTreetId: 'ShopByTreetId',
    ShopIntegrationsByShopId: 'ShopIntegrationsByShopId',
    ShopIntegrationByShopIdAndIntegrationType: 'ShopIntegrationByShopIdAndIntegrationType',
    ShopIntegrationInstalledStatusByShopIdAndIntegrationType:
      'ShopIntegrationInstalledStatusByShopIdAndIntegrationType',
    ShopAlloyTokenByShopId: 'ShopAlloyTokenByShopId',
    BrandHealthActions: 'BrandHealthActions',
    BrandHealthActionByKey: 'BrandHealthActionByKey',
    MostRecentBrandHealthLogByShopId: 'MostRecentBrandHealthLogByShopId',
    GetPriceDropConfigBySharetribeListingId: 'GetPriceDropConfigBySharetribeListingId',
    ISOSavedSearchesByEmail: 'ISOSavedSearchesByEmail',
  },
  Mutation: {
    AddShipFromAddressToBundle: 'AddShipFromAddressToBundle',
    CreateCancellation: 'CreateCancellation',
    CreateCartItem: 'CreateCartItem',
    UpsertDispute: 'UpsertDispute',
    CreateFavoritedItem: 'CreateFavoritedItem',
    CreateFulfillmentFromTrackingInfo: 'CreateFulfillmentFromTrackingInfo',
    UpsertListing: 'UpsertListing',
    CreateListingFeedback: 'CreateListingFeedback',
    CreateUser: 'CreateUser',
    DeleteDraftListing: 'DeleteDraftListing',
    PublishDraftListing: 'PublishDraftListing',
    RemoveCartItem: 'RemoveCartItem',
    RemoveFavoritedItem: 'RemoveFavoritedItem',
    UpdateAddress: 'UpdateAddress',
    UpdateBundle: 'UpdateBundle',
    UpdateBundleItem: 'UpdateBundleItem',
    UpdateUser: 'UpdateUser',
    UpsertDraftListing: 'UpsertDraftListing',
    UpsertGeneralSavedSearch: 'UpsertGeneralSavedSearch',
    UpsertISOSavedSearch: 'UpsertISOSavedSearch',
    UpsertPhotosOnDraft: 'UpsertPhotosOnDraft',
    UpsertPriceDropConfig: 'UpsertPriceDropConfig',
    UpdateUserShipFromCountry: 'UpdateUserShipFromCountry',
    UpsertShopIntegration: 'UpsertShopIntegration',
  },
  Fragment: {
    CoreAddress: 'CoreAddress',
    CoreBundle: 'CoreBundle',
    CoreBundleItem: 'CoreBundleItem',
    CoreDisbursement: 'CoreDisbursement',
    CoreDiscountLineItem: 'CoreDiscountLineItem',
    CoreDraftListing: 'CoreDraftListing',
    CoreFulfillment: 'CoreFulfillment',
    CoreLineItem: 'CoreLineItem',
    CoreListing: 'CoreListing',
    CoreListingLineItem: 'CoreListingLineItem',
    CoreOrder: 'CoreOrder',
    CoreProduct: 'CoreProduct',
    CorePartialProduct: 'CorePartialProduct',
    CoreProductVariant: 'CoreProductVariant',
    CoreRefund: 'CoreRefund',
    CoreReturnInsuranceLineItem: 'CoreReturnInsuranceLineItem',
    CoreShippingLineItem: 'CoreShippingLineItem',
    CoreShopIntegration: 'CoreShopIntegration',
    CoreTaxLineItem: 'CoreTaxLineItem',
  },
};
